import { Component, AfterViewInit, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { ResizeEvent } from 'angular-resizable-element';
import { AuthService } from '../services/auth.service';
import * as io from 'socket.io-client';
import { Router } from '@angular/router';
import { GpsService } from '../services/gps.service';
import swal from 'sweetalert';
import * as jsts from 'jsts';
import { ToastrService } from 'ngx-toastr';
import { JwtHelperService } from '@auth0/angular-jwt';
// News impots
import * as moment from 'moment-timezone';
import { NgxSpinnerService } from 'ngx-spinner';
// News impots
import { ExcelService } from '../services/excel.service';
import * as leafletPip from '@mapbox/leaflet-pip';
// Operadores
import { OperadoresService } from '../services/operadores.service';
import * as modal from 'bootstrap';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { THIS_EXPR, ifStmt } from '@angular/compiler/src/output/output_ast';
// Usuarios & Restablecer contraseña
import { UsuariosService } from '../services/usuarios.service';
// Usuarios & Restablecer contraseña


declare let L: any;
declare let google: any;

@Component({
  selector: 'app-unidades',
  templateUrl: './unidades.component.html',
  styleUrls: ['./unidades.component.css']
})
export class UnidadesComponent implements AfterViewInit, OnInit {
  subscribeUsuarios: any;
  @Input()
  public myInput: MouseEvent;

  constructor(
    private gps: GpsService,
    public auth: AuthService,
    private toastr: ToastrService,
    private router: Router,
    public jwtHelper: JwtHelperService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private operadoresService: OperadoresService,
    private usuarios: UsuariosService
  ) {
    moment.locale('es');
  }

  @ViewChild('info') info: ElementRef;

  // Variables para Soket
  private url = 'https://vigiliner.com:1798';
  private socket;
  // Variables para Mapa
  public L: any;
  public google: any;
  public map;
  // Variables para GPS
  public markers = new L.FeatureGroup();
  public filtro = '';
  public style: object = {};
  public dispositivo = {};
  public dispositivoss = [];
  public divInformacion: object;
  public arrayOfKeys;
  public seteo_valoresseteo_valores = true;
  public datosXls: Array<any> = [];
  public respuestaParo: any;
  // Variables Reportes
  public formModel = {
    fechastart: moment().format('YYYY-MM-DD'),
    horastart: '00:00',
    fechaend: moment().format('YYYY-MM-DD'),
    horaend: moment().format('HH:mm')
  };
  public errorFechas = null;
  public divReportes: Array<any> = [];
  public selecTipo = 'todos';
  public markersRecorrido = [];
  public markersMovimiento = new L.layerGroup();
  public markersParadaMenor = new L.layerGroup();
  public markersParadaMayor = new L.layerGroup();
  public markersEstacionado = new L.layerGroup();
  public markersTodos = new L.layerGroup();
  public displayedmarkers;
  public polyline = new L.layerGroup();
  public polylineDecora = new L.layerGroup();
  // Variable para permiso de envio de comandos
  public comandos: boolean;
  // Variables Geocercas
  public drawMenu;
  public drawnItems;
  public geocercasList = [];
  // Variables para Operadores
  model: any = {};
  public listadoOperadores: Array<any> = [];
  public listadoAsignacion: Array<any> = [];
  public listadoIncidencias: Array<any> = [];
  historial: any = {};
  public unidadesXoperador: Array<any> = [];
  // Variables para Unidades
  public listadoUnidades: Array<any> = [];
  public servicioUnidades = {};
  public iconos: Array<any> = [];
  public colores: Array<any> = [];
  public historialUnidad = [];
  public listadoAsignaciones: Array<any> = [];
  public listadoServicios: Array<any> = [];
  // Variables para Usuarios
  public listadoUsuarios: Array<any> = [];
  public TodasUnidades: Array<any> = [];

  public contadorOfoto = true;
  public contadorPersonasE = 0;
  public contadorPersonasS = 0;

  /**
   * Para exportar reportes a excel
   * @param nombre Es econjunto de Unidad y rango de fecha
  **/
  exportAsXLSX(nombre): void {
    this.excelService.exportAsExcelFile(this.datosXls, nombre);
  }
  /**
   * valida cuales el maximo y mino que se puede redimensionar
   * la barra lateral de listado de unidades
   * @param event contiene las medidas de la barra.
   *
  **/
  validate(event: ResizeEvent): boolean {
    const MIN_DIMENSIONS_PX = 0;
    const MAX_DIMENSIONS_PX = 200;

    if (
      event.rectangle.width &&
      (event.rectangle.width < MIN_DIMENSIONS_PX ||
        event.rectangle.width > MAX_DIMENSIONS_PX)
    ) {
      return false;
    }
    return true;
  }
  /**
   * Ajusta la barra lateral de listado de unidades
   * a su nuevo tamaño acomidando todo
   * la barra lateral de listado de unidades
   * @param event contiene las medidas de la barra.
   *
  **/
  onResizeEnd(event: ResizeEvent): void {
    this.style = {
      width: `${event.rectangle.width}px`,
    };

    document.getElementById('mapa').style.left = `${event.rectangle.width}px`;
    document.getElementById('info').style.left = `${event.rectangle.width}px`;
  }
  /**
   * Se muestra todo lo que carga de entrada que son
   * Las unidades, operadores usuarios, validar si ha echo el cambio
   * inicial de contraseña, revisar que permisos tiene el usuario
   *
  **/
  ngOnInit() {
    //  Valida si tienes permisos para enviar comandos
    // tslint:disable-next-line:triple-equals
    if (this.jwtHelper.decodeToken(localStorage.getItem('access_token')).permisoID == 4) {
      this.comandos = false;
    } else {
      this.comandos = true;
    }
    document.oncontextmenu = function () { return false; };
    /**
      * Funcion de restablecimiento de contraseña
      * que se auto genera.
    **/
    this.usuarios.revisarResetPass().toPromise().then(result => {
      if (result.cambio === 1) {
        this.abrirModalResetPass();
      }
    },
      err => { this.auth.logout(); this.router.navigate(['login']); }
    );
    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param listadoUsuarios Se almacenan la informacion de los usuarios
    **/
    this.usuarios.listadoUsiarios().toPromise().then(result => {
      const temporal: Array<any> = [];
      result.forEach(element => {
        temporal.push({
          usuarioID: element.usuarioID,
          nombres: element.nombres,
          apellidos: element.apellidos,
          email: element.email,
          telefono: (element.telefono == null || element.telefono === '') ? 'Sin teléfono' : element.telefono,
          unidadesAlias: (element.unidadesAlias == null) ? 'No hay unidades asignadas' : element.unidadesAlias,
          unidadesID: (element.unidadesID == null) ? null : element.unidadesID.split(',')
        });
      });
      this.listadoUsuarios = temporal;
    },
      err => { this.auth.logout(); this.router.navigate(['login']); }
    );
    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param listadoOperadores Se almacenan la informacion de los operadores
    **/
    this.operadoresService.listadoOperadores().toPromise().then(result => {
        const temporal: Array<any> = [];
        result.forEach(element => {
          temporal.push({
            id: element.id,
            uid: element.uid,
            nombre: element.nombre,
            paterno: element.paterno,
            materno: element.materno,
            empleado: (element.empleado === null) ? ' --- ' : element.empleado,
            licencia: element.licencia
          });
        });
        this.listadoOperadores = temporal;
      },
      err => {
        this.auth.logout();
        this.router.navigate(['login']);
      }
    );

    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param geocercasList Se almacenan la informacion de los operadores
    **/
   this.gps.geocercas().toPromise().then(result => {
    const temporal: Array<any> = [];
    result.forEach(element => {
      temporal.push({
        id: element.idtbl_geocercas,
        uid: element.color,
        nombre: element.nombre,
        unidades: element.unidades,
        cliente: element.tbl_clientes_idtbl_clientes,        
        fecha: element.fecha_creacion
      });
    });
    this.geocercasList = temporal;
  },
  err => {
    this.auth.logout();
    this.router.navigate(['login']);
  }
);
    
   
    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param dispositivo Se almacenan la informacion de las unidades
      * Su ultimo reporte, coordenadas, estado, etc.
      * @param dispositivoss sirve para mantener el orden de las unidades
      * @param markers Todas las unidades para mostrar en el mapa
    **/
    this.gps.getTodos().toPromise().then(result => {
      const temporal = this.listadoUnidades;
      this.dispositivoss = result;
      result.forEach(elemento => {
        // @ts-ignore
        this.dispositivo[elemento.imei] = elemento;
        let clase = '', faltan = 'Falta ';
        if (elemento.fechaServicio != null) {
          const dateNow = moment();
          const periodo = elemento.periodo.split('-');
          const fechaAvisar = moment(elemento.fechaServicio).subtract(periodo[0], periodo[1]).format('YYYY-MM-DD');
          if (dateNow.isBefore(fechaAvisar)) {
            clase = '';
          } else if (dateNow.isBetween(fechaAvisar, elemento.fechaServicio)) {
            clase = 'table-warning';
          } else if (dateNow.isSameOrAfter(fechaAvisar)) {
            clase = 'table-danger';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
            faltan = 'Necesita servicio por fecha.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') < 0) {
            faltan = 'Necesita servicio por fecha. Se ha pasado por ' +
              (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
          }
        }
        let periodo_ = '';
        switch (elemento.periodo) {
          case '1-month':
            periodo_ = '1 Mes';
            break;
          case '2-month':
            periodo_ = '2 Meses';
            break;
          case '3-month':
            periodo_ = '3 Meses';
            break;
          case '4-month':
            periodo_ = '4 Meses';
            break;
          default:
            periodo_ = '';
            break;
        }
        temporal.push({
          imei: elemento.imei,
          uidUnidad: elemento.uidUnidad,
          alias: elemento.alias,
          // tslint:disable-next-line:max-line-length
          modelo: (elemento.marca == null && elemento.modelo == null && elemento.anio == null) ? ' --- ' : elemento.marca + ' ' + elemento.modelo + ' ' + elemento.anio,
          modeloAct: (elemento.modelo == null) ? ' --- ' : elemento.modelo,
          anioAct: (elemento.anio == null) ? ' --- ' : elemento.anio,
          marcaAct: (elemento.marca == null) ? ' --- ' : elemento.marca,
          serie: elemento.serie,
          placas: (elemento.placas == null) ? ' --- ' : elemento.placas,
          consumo: (elemento.consumo == null) ? ' --- ' : elemento.consumo,
          icono: elemento.icono,
          color: elemento.color,
          fechaServicio: (elemento.fechaServicio == null) ? ' --- ' : moment(elemento.fechaServicio).format('DD-MM-YYYY'),
          periodo: (elemento.periodo == null) ? '' : elemento.periodo,
          txtperiodo: (periodo_ === '') ? ' --- ' : periodo_,
          faltan: (elemento.fechaServicio == null) ? '' : 'Por fecha: ' + faltan,
          clase: clase,
          km: (elemento.kmServicio == null) ? ' --- ' : elemento.kmServicio,
          kmActual: 'Procesando...',
          faltanKM: '',
          claseKm: '',
          uidOperador: elemento.uidOperador,
          // tslint:disable-next-line:max-line-length
          operador: (elemento.nombre == null && elemento.paterno == null && elemento.materno == null) ? 'Sin asignación' : elemento.nombre + ' ' + elemento.paterno + ' ' + elemento.materno,
          licencia: (elemento.licencia == null) ? 'Sin asignación' : elemento.licencia,
          uidGeo: elemento.uidGeo,
          nombreGeo: (elemento.nombreGeo == null) ? 'Sin asignación' : elemento.nombreGeo
        });
        // @ts-ignore
        if (elemento.json != null) {
          // @ts-ignore
          this.dispositivo[elemento.imei].geocerca = L.geoJSON(JSON.parse(elemento.json), {});
        }
        this.dispositivo[elemento.imei].visible = true;
        this.dispositivo[elemento.imei].posicion = {};
        // contador personas
        this.dispositivo[elemento.imei].contadorPersonasE = 0;
        this.dispositivo[elemento.imei].contadorPersonasS = 0;
        this.dispositivo[elemento.imei].sensorGasolina = {};
        this.dispositivo[elemento.imei].sensorGasolina.porcentaje = 0;
        this.dispositivo[elemento.imei].sensorGasolina.volumen = 0;
        this.dispositivo[elemento.imei].sensorGasolina.claseFuelSensor = 'danger';
        // @ts-ignore
        if (elemento.estado !== undefined && elemento.estado[0] !== undefined && elemento.estado[0].fecha !== undefined) {
          // @ts-ignore
          const diff = moment().diff(elemento.estado[0].fecha, 'hours');
          // tslint:disable-next-line:curly
          if (diff <= 1) {
            this.dispositivo[elemento.imei].estatus = 'online';
          } else if (diff > 1 && diff <= 24) {
            this.dispositivo[elemento.imei].estatus = 'offline';
          } else {
            this.dispositivo[elemento.imei].estatus = 'error';
          }

          // @ts-ignore
          this.dispositivo[elemento.imei].fechaHoraUltimoReporte = moment(elemento.estado[0].fecha);
          // @ts-ignore
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].fechaHoraUltimoReporteFormato = moment(elemento.estado[0].fecha).format('dddd DD [de] MMMM [de] YYYY, h:mm:ss a');
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = this.diferenciaTiempo(this.dispositivo[elemento.imei].fechaHoraUltimoReporte, elemento.imei);
          this.dispositivo[elemento.imei].time = setInterval(() => {
            if (this.dispositivo[elemento.imei].fechaHoraUltimoReporte) {
              // tslint:disable-next-line:max-line-length
              this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = this.diferenciaTiempo(this.dispositivo[elemento.imei].fechaHoraUltimoReporte, elemento.imei);
            }
          }, 60000);
        } else {
          this.dispositivo[elemento.imei].ultimo_reporte = false;
          this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = 'N/A';
          this.dispositivo[elemento.imei].fechaHoraUltimoReporte = false;
          this.dispositivo[elemento.imei].fechaHoraUltimoReporteFormato = '-';
        }
        // @ts-ignore
        if (elemento.estado !== undefined && elemento.estado[0] !== undefined && elemento.estado[0].ultimas_coordenadas[0] !== undefined) {
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Altitude = elemento.estado[0].ultimas_coordenadas[0].trama.Altitude;
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Longitude = elemento.estado[0].ultimas_coordenadas[0].trama.Longitude;
          // @ts-ignore
          // tslint:disable-next-line:radix
          this.dispositivo[elemento.imei].posicion.Azimuth = parseInt(elemento.estado[0].ultimas_coordenadas[0].trama.Azimuth);
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Latitude = elemento.estado[0].ultimas_coordenadas[0].trama.Latitude;
          // Agregado
          // tslint:disable-next-line:max-line-length
          const icono = (this.dispositivo[elemento.imei].icono == null || this.dispositivo[elemento.imei].icono.length === 0) ? 'default' : this.dispositivo[elemento.imei].icono;
          // tslint:disable-next-line:max-line-length
          const color = (this.dispositivo[elemento.imei].color == null || this.dispositivo[elemento.imei].color.length === 0) ? 'black' : this.dispositivo[elemento.imei].color;

          // Kilometraje
          // @ts-ignore
          if ((elemento.estado[0].ultimas_coordenadas[0].trama.Mileage) !== undefined) {
            const indexUnidad = temporal.map(x => x.imei).indexOf(elemento.imei);
            if (indexUnidad !== -1) {
              if (temporal[indexUnidad].km !== ' --- ') {
                let falta = null;
                const km = parseFloat(temporal[indexUnidad].km);
                // @ts-ignore
                // tslint:disable-next-line:max-line-length
                if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage >= (km - 200) && elemento.estado[0].ultimas_coordenadas[0].trama.Mileage < km) {
                  temporal[indexUnidad].claseKm = 'table-warning';
                  // @ts-ignore
                  falta = 'Faltan ' + (km - elemento.estado[0].ultimas_coordenadas[0].trama.Mileage).toFixed(2) + ' Km.';
                } else
                  // @ts-ignore
                  if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage === km) {
                    temporal[indexUnidad].claseKm = 'table-danger';
                    falta = 'Necesita servicio por kilometraje.';
                  } else
                    // @ts-ignore
                    if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage > km) {
                      temporal[indexUnidad].claseKm = 'table-danger';
                      // @ts-ignore
                      // tslint:disable-next-line:max-line-length
                      falta = 'Necesita servicio por kilometraje. Se ha pasado por  ' + (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage - km).toFixed(2) + ' Km.';
                    } else {
                      // @ts-ignore
                      falta = 'Faltan ' + (km - elemento.estado[0].ultimas_coordenadas[0].trama.Mileage).toFixed(2) + ' Km.';
                    }
                temporal[indexUnidad].faltanKM = (falta == null) ? '' : '\n Por kilometraje: ' + falta;
              }
              // @ts-ignore
              temporal[indexUnidad].kmActual = elemento.estado[0].ultimas_coordenadas[0].trama.Mileage;
            }
            // Agregado
          }

          // Agregado
          const customPopup = '<table><tr><th colspan="2" aling="center">' + this.dispositivo[elemento.imei].alias + '</th></tr></table>';
          // @ts-ignore
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].marker = L.marker([elemento.estado[0].ultimas_coordenadas[0].trama.Latitude, elemento.estado[0].ultimas_coordenadas[0].trama.Longitude],
            {
              rotationOrigin: 'center center'
            })
            .bindPopup(customPopup)
            .on('mouseover', function (e) {
              this.openPopup();
            })
            .on('mouseout', function (e) {
              this.closePopup();
            })
            .setIcon(L.divIcon({
              html: '',
              iconSize: [50, 50],
              // @ts-ignore
              // tslint:disable-next-line:max-line-length
              className: elemento.imei + ' ' + icono + color + ' ' + this.icono(parseInt(elemento.estado[0].ultimas_coordenadas[0].trama.Azimuth))
            }));

          this.dispositivo[elemento.imei].paroDeMotor = false;
          this.dispositivo[elemento.imei].salidaTres = false;

          this.divInformacion = this.dispositivo[elemento.imei];

          this.dispositivo[elemento.imei].marker.on('click', (data) => {
            this.abrirInfo(elemento.imei);
          });

          this.markers.addLayer(this.dispositivo[elemento.imei].marker);

          if (this.dispositivo[elemento.imei].geocerca !== undefined) {
            // tslint:disable-next-line:max-line-length
            if (leafletPip.pointInLayer([this.dispositivo[elemento.imei].posicion.Latitude, this.dispositivo[elemento.imei].posicion.Longitude], this.dispositivo[elemento.imei].geocerca).length === 0) {
              this.dispositivo[elemento.imei].classGeocerca = 'text-danger';
            } else {
              this.dispositivo[elemento.imei].classGeocerca = '';
            }
          }

        }

        try {
          // @ts-ignore
          this.seteo_valores(elemento.imei, elemento.estado[0].ultimas_coordenadas[0].trama);
          // @ts-ignore
          this.can100(elemento.imei, elemento.estado[0].ultimas_coordenadas[0].trama);
        } catch (error) {

        }

      });
    },
      err => { this.auth.logout(); this.router.navigate(['login']); }
    );
  }
  /**
   * Carga el mapa con las unidades, las geocercas,
   * la actualización de los sockets
   *
  **/
  ngAfterViewInit() {
    

    

    

    try {
      // tslint:disable-next-line:max-line-length
      this.socket = io.connect(this.url, { query: { 'navegador': 'yes', 'uid': this.jwtHelper.decodeToken(localStorage.getItem('access_token')).clienteID } });
    } catch (error) {
      return false;
    }

    /*Actualizacion desde el socket */
    this.socket.on('geocerca', (datos) => {
      if (datos.estatus) {
        this.dispositivo[datos.imei].classGeocerca = '-';
      } else {
        this.dispositivo[datos.imei].classGeocerca = 'text-danger';
      }
    });
    const x = 1;
    this.socket.on('update', (reporte) => {


      if (this.dispositivo[reporte.data.IMEI] !== undefined && this.dispositivo[reporte.data.IMEI].marker !== undefined) {
        if (this.dispositivo[reporte.data.IMEI].fechaHoraUltimoReporte <= moment(reporte.data.fecha)) {

          // Velocidad
          if (reporte.data.Speed !== undefined && reporte.data.Speed !== '0.0') {
            this.dispositivo[reporte.data.IMEI].velocidad = reporte.data.Speed + 'Km/h';
            this.dispositivo[reporte.data.IMEI].velocidadClass = 'text-success';
          } else {
            this.dispositivo[reporte.data.IMEI].velocidad = null;
            this.dispositivo[reporte.data.IMEI].velocidadClass = null;
          }
          //

          if (reporte.actualizacion_posicion === '1') {
            this.dispositivo[reporte.data.IMEI].marker.slideTo([reporte.data.Latitude, reporte.data.Longitude], {
              duration: 2000,
              keepAtCenter: false,
              icono: this.dispositivo[reporte.data.IMEI].icono,
              color: this.dispositivo[reporte.data.IMEI].color,
              imei: this.dispositivo[reporte.data.IMEI].imei,
              className: this.icono(parseInt(reporte.data.Azimuth))
            });

            // actualizacion de valores de posicion
            this.dispositivo[reporte.data.IMEI].posicion.Azimuth = parseInt(reporte.data.Azimuth);
            this.dispositivo[reporte.data.IMEI].posicion.Altitude = reporte.data.Altitude;
            this.dispositivo[reporte.data.IMEI].posicion.Longitude = reporte.data.Longitude;
            this.dispositivo[reporte.data.IMEI].posicion.Latitude = reporte.data.Latitude;

          }/*end if*/

          this.dispositivo[reporte.data.IMEI].fechaHoraUltimoReporte = moment(reporte.data.fecha);
          this.dispositivo[reporte.data.IMEI].fechaHoraUltimoReporteFormato = moment(reporte.data.fecha).format('dddd DD [de] MMMM [de] YYYY, h:mm:ss a');

          // Boton de Panico
          if (reporte.data.Comando === '+RESP:GTSOS') {
            this.sos(this.dispositivo[reporte.data.IMEI].alias, reporte.data.IMEI);
          }

          // Boton de Panico
          if (reporte.data.Comando === '+RESP:GTCAN') {
            this.can100(reporte.data.IMEI, reporte.data);
          }

          // camara
          if (reporte.data.Comando === '+RESP:GTFTP') {
            const customPopup = '<div><p>Foto tomanda en la unidad: <strong>' + reporte.data.alias + '</strong></p><p>Fecha y Hora: <strong>' + moment(reporte.data.fecha).format('dddd DD [de] MMMM [de] YYYY, h:mm:ss a') + '</strong></p><img src="https://vigiliner.com/uploads/' + reporte.data.FileName + '" alt=""></div>';

            const firefoxIcon = L.icon({
              iconUrl: '/assets/images/photo.png',
              iconSize: [38, 30], // size of the icon
              popupAnchor: [0, 0]
            });


            // specify popup options
            const customOptions = {
              'maxWidth': '320',
              'className': 'photo'
            };

            const marker = L.marker([reporte.data.Latitude, reporte.data.Longitude],
              {
                icon: firefoxIcon
              })
              .bindPopup(customPopup, customOptions);

            this.markers.addLayer(marker.openPopup());

            this.map.setView([reporte.data.Latitude, reporte.data.Longitude], 20);

          }

          // Estatus
          this.dispositivo[reporte.data.IMEI].estatus = 'online';
          //

          // @ts-ignore
          this.seteo_valores(reporte.data.IMEI, reporte.data);

        }/*eND if*/
      }
    });


  }
  /**
    * Mostrar el listado de las Gocercas
  **/
  verGeocercas() {
    $('#geocercas').css('background-color', '#f7f78b');
    setTimeout(function () {
      $('#geocercas').css('background-color', '#fff');
    }, 500);
    document.getElementById('geocercas').classList.add('abierto');
    this.map.addControl(this.drawMenu);
  }
  /**
    * Ovultar el listado de geocercas
  **/
  cerrarGeocercas() {
    // @ts-ignore
    document.getElementById('geocercas').classList.remove('abierto');
    this.map.removeControl(this.drawMenu);
  }
  /**
    * Al seleccionar una geocerca centra el mapa
    * enfocando la geocerca selecionada
    * @param geoJson trae las coordenadas
  **/
  centrarGeocerca(geoJson) {
    this.map.fitBounds(geoJson.getBounds());
  }
  
  /**
    * Elimina la geocerca seleccionada
    * @param key Clave unica de Geocerca
  **/
  eliminarGeocerca(key) {

    const _geocercas = this.geocercasList;

    // @ts-ignore
    swal({
      title: '¡Advertencia!',
      text: '¿Desea eliminar esta geocerca?',
      icon: 'warning',
      buttons: ['Cancelar', 'Continuar'],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CONFIRMAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          })
            .then(value => {
              if (!value) { throw null; }

              if (value !== 'CONFIRMAR') { throw true; }



              /* eliminar Geocerca */
              this.gps.eliminarGeocerca(key).toPromise().then(data => {
                // @ts-ignore
                if (data.error) {
                  swal({
                    icon: 'error',
                    // @ts-ignore
                    title: data.text
                  });
                } else {
                  this.drawnItems.removeLayer(key);
                  _geocercas.splice(_geocercas.findIndex(geo => geo.idtbl_geocercas === key), 1);
                  swal({
                    icon: 'success',
                    title: 'Eliminación de geocerca exitosa.'
                  });
                }
              });

            })
            .catch(err => {
              if (err) {
                swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
              } else {
                swal.stopLoading();
                // @ts-ignore
                swal.close();
              }
            });
        }
      });
  }
  /**
    * Revisa si la unidad esta dentro de la Geocerca
    * @param marker Contiene las coordenadas de la unidad
    * @param poly Contiene las coordenadas de la Geocerca
  **/
  isMarkerInsidePolygon(marker, poly) {
    const polyPoints = poly.getLatLngs();
    const x = marker.getLatLng().lat, y = marker.getLatLng().lng;

    let inside = false;
    for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
      const xi = polyPoints[i].lat, yi = polyPoints[i].lng;
      const xj = polyPoints[j].lat, yj = polyPoints[j].lng;

      const intersect = ((yi > y) !== (yj > y))
        && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) { inside = !inside; }
    }

    return inside;
  }
  /**
    * Centra mapa al seleciconar un a unidad
    * @param imei Identificador de unidad
  **/
  centrarMapa(imei) {

    if (this.dispositivo[imei].visible === false) { return false; }

    this.map.setView([this.dispositivo[imei].posicion.Latitude, this.dispositivo[imei].posicion.Longitude], 20);
    this.dispositivo[imei].marker.openPopup();
  }
  /**
    * Obtiene la direccion de los puntos
    * @param lat Latitud
    * @param lon Longitud
    * @param imei Identificador de unidad
  **/
  obtenerDireccion(lat, lon, imei) {
    if (lat !== undefined && lon !== undefined) {
      this.gps.direccion(lat, lon, 0).toPromise().then(data => {
        // @ts-ignore
        if (data.result[0] !== undefined && data.result[0].formatedFull !== undefined) {
          // @ts-ignore
          this.dispositivo[imei].direccion = data.result[0].formatedFull;
        } else { this.dispositivo[imei].direccion = '-'; }
      });
    }// end if
  }
  /**
    * Cuando se activa el boton de panico nos muestra
    * una alerta en la plataforma de la unidad que lo a activado
    * @param nombre Alias de la unidad
    * @param imei Identificador de unidad
  **/
  sos(nombre, imei) {
    // @ts-ignore
    $('#chatAudio')[0].play();

    this.toastr.warning('Botón de panico activado desde la unidad ' + nombre + '.', '¡Advertencia!', {
      disableTimeOut: true,
      closeButton: true,
      positionClass: 'toast-top-center'
    }).onHidden.toPromise().then(data => {
      // @ts-ignore
      $('#chatAudio')[0].pause();
      this.centrarMapa(imei);
    });
    // @ts-ignore
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    } else {
      const notificacion = new Notification('¡Advertencia!',
        {
          icon: 'https://image.winudf.com/v2/image/cGIuY29tLmJyX2ljb25fMF8yZDQwZTE4Yw/icon.png?w=170&fakeurl=1&type=.png',
          body: 'Botón de panico activado desde la unidad ' + nombre + '.',
          // @ts-ignore
          requireInteraction: true,
          vibrate: [200, 100, 200]
        }
      );
      notificacion.onclick = function () {
        // window.open("https://jonathanmelgoza.com/blog/");
      };
    }
  }
  /**
    * Actileto DesactiletParo de motor
    * @param id Clave unica Gps
    * @param imei Identificador de unidad
    * @param nombre Alias de la unidad
    * @param event Enviado del switch paraa saber si se activa o desactiva
    * @param tipo tipo de comando a enviar
  **/
  paroDeMotor(id, imei, nombre, event) {
    event.preventDefault();
    let tipo = '', leyenda = '';
    if (event.target.checked) {
      // tslint:disable-next-line:prefer-const
      tipo = 'desactivar', leyenda = 'activar';
      this.dispositivo[imei].paroDeMotor = false;
    } else {
      // tslint:disable-next-line:prefer-const
      tipo = 'activar', leyenda = 'desactivar';
      this.dispositivo[imei].paroDeMotor = true;
    }
    // @ts-ignore
    swal({
      title: '¡Advertencia!',
      text: '¿Desea ' + leyenda + ' el paro de motor para \'' + nombre + '\'?',
      icon: 'warning',
      buttons: ['Cancelar', 'Continuar'],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CONFIRMAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          })
            .then(value => {
              if (!value) { throw null; }

              if (value !== 'CONFIRMAR') { throw true; }

              this.dispositivo[imei].paroDeMotorClass = '';

              this.gps.comando(id, tipo).toPromise().then(data => {
                swal({
                  title: 'Respuesta del servidor:',
                  // @ts-ignore
                  text: data.respuesta
                });
              });

            })
            .catch(err => {
              if (err) {
                swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
              } else {
                swal.stopLoading();
                // @ts-ignore
                swal.close();
              }
            });
        }
      });
  }

  salidaTres(id, imei, nombre, event) {
    event.preventDefault();
    let tipo = '', leyenda = '';
    if (event.target.checked) {
      tipo = 'desactivarchapa', leyenda = 'activar';
      this.dispositivo[imei].salidaTres = false;
    } else {
      tipo = 'activarchapa', leyenda = 'desactivar';
      this.dispositivo[imei].salidaTres = true;
    }
    // @ts-ignore
    swal({
      title: '¡Advertencia!',
      text: '¿Desea ' + leyenda + ' la salida adicional para \'' + nombre + '\'?',
      icon: 'warning',
      buttons: ['Cancelar', 'Continuar'],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CONFIRMAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          })
            .then(value => {
              if (!value) { throw null; }

              if (value !== 'CONFIRMAR') { throw true; }

              this.dispositivo[imei].salidaTresClass = '';

              this.gps.comando(id, tipo).toPromise().then(data => {
                swal({
                  title: 'Respuesta del servidor:',
                  // @ts-ignore
                  text: data.respuesta
                });
              });

            })
            .catch(err => {
              if (err) {
                swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
              } else {
                swal.stopLoading();
                // @ts-ignore
                swal.close();
              }
            });
        }
      });
  }
  /**
    * Actiletla alarma de la unidad
    * @param id Clave unica Gps
    * @param imei Identificador de unidad
    * @param nombre Alias de la unidad
  **/
  alarma(id, imei, nombre, event) {
    event.preventDefault();

    // @ts-ignore
    swal({
      title: '¡Advertencia!',
      text: '¿Desea actiletla alarma sonora para \'' + nombre + '\'?',
      icon: 'warning',
      buttons: ['Cancelar', 'Continuar'],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CONFIRMAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          })
            .then(value => {
              if (!value) { throw null; }

              if (value !== 'CONFIRMAR') { throw true; }

              this.gps.comando(id, 'alarma').toPromise().then(data => {
                swal({
                  title: 'Respuesta del servidor:',
                  // @ts-ignore
                  text: data.respuesta
                });
              });

            })
            .catch(err => {
              if (err) {
                swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
              } else {
                swal.stopLoading();
                // @ts-ignore
                swal.close();
              }
            });
        }
      });
  }

  camara(id, imei, nombre, event) {
    event.preventDefault();
    this.dispositivo[imei].foto = true;

    // @ts-ignore
    swal({
      title: '¡Advertencia!',
      text: '¿Desea solicitar instantanea para \'' + nombre + '\'?',
      icon: 'warning',
      buttons: ['Cancelar', 'Continuar'],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CONFIRMAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          })
            .then(value => {
              if (!value) { throw null; }

              if (value !== 'CONFIRMAR') { throw true; }

              this.gps.comando(id, 'foto').toPromise().then(data => {
                swal({
                  title: 'Respuesta del servidor:',
                  // @ts-ignore
                  text: data.respuesta
                });
              });

            })
            .catch(err => {
              if (err) {
                swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
              } else {
                swal.stopLoading();
                // @ts-ignore
                swal.close();
              }
            });
        }
      });
  }
  /**
    * Reiniciar el gps
    * @param id Clave unica Gps
    * @param imei Identificador de unidad
    * @param nombre Alias de la unidad
  **/
  reiniciar(id, imei, nombre, event) {
    event.preventDefault();

    // @ts-ignore
    swal({
      title: '¡Advertencia!',
      text: '¿Desea reiniciar la unidad \'' + nombre + '\'?',
      icon: 'warning',
      buttons: ['Cancelar', 'Continuar'],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CONFIRMAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          })
            .then(value => {
              if (!value) { throw null; }

              if (value !== 'CONFIRMAR') { throw true; }

              this.gps.comando(id, 'reiniciar').toPromise().then(data => {
                swal({
                  title: 'Respuesta del servidor:',
                  // @ts-ignore
                  text: data.respuesta
                });
              });

            })
            .catch(err => {
              if (err) {
                swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
              } else {
                swal.stopLoading();
                // @ts-ignore
                swal.close();
              }
            });
        }
      });
  }
  /**
    * Solicitar al gps reporte su posicion
    * @param id Clave unica Gps
    * @param imei Identificador de unidad
    * @param nombre Alias de la unidad
  **/
  posicion(id, imei, nombre, event) {
    event.preventDefault();

    // @ts-ignore
    swal({
      title: '¡Advertencia!',
      text: '¿Desea solicitar posición para \'' + nombre + '\'?',
      icon: 'warning',
      buttons: ['Cancelar', 'Continuar'],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CONFIRMAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          })
            .then(value => {
              if (!value) { throw null; }

              if (value !== 'CONFIRMAR') { throw true; }

              this.gps.comando(id, 'posicion').toPromise().then(data => {
                swal({
                  title: 'Respuesta del servidor:',
                  // @ts-ignore
                  text: data.respuesta
                });
              });

            })
            .catch(err => {
              if (err) {
                swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
              } else {
                swal.stopLoading();
                // @ts-ignore
                swal.close();
              }
            });
        }
      });
  }
  /**
    * Mostrar u Ocultar las unidades del mapa
    * @param imei Identificador de unidad
    * @param e Enviado del check para saber si se muestra u oculta
  **/
  checkFuncion(e, imei) {
    if (e.target.checked) {
      this.dispositivo[imei].visible = true;
      this.map.addLayer(this.dispositivo[imei].marker);
    } else {
      this.dispositivo[imei].visible = false;
      this.map.removeLayer(this.dispositivo[imei].marker);
      if ((typeof this.dispositivo[imei].streetview) === 'object') {
        this.cerrarInfo(imei);
      }
    }
  }
  /**
    * Mostrar u Ocultar todas las unidades del mapa
    * @param e Enviado del check para saber si se muestran u ocultan
  **/
  checkFuncionAll(e) {

    if (e.target.checked) {
      for (const key of this.arrayOfKeys) {
        this.dispositivo[key].visible = true;
        this.map.addLayer(this.markers);
      }
    } else {
      for (const key of this.arrayOfKeys) {
        this.dispositivo[key].visible = false;
        this.map.removeLayer(this.markers);
        if ((typeof this.dispositivo[key].streetview) === 'object') {
          this.cerrarInfo(key);
        }
      }
    }


  }
  /**
    * Para girar el icono segun su Azimuth
    * @param grados Azimuth enviado por el gps
  **/
  icono(grados) {
    let className;
    switch (true) {
      case (grados > 349 || grados <= 11): {
        className = 'uno';
        break;
      }
      case (grados > 11 && grados <= 34): {
        className = 'dos';
        break;
      }
      case (grados > 34 && grados <= 56): {
        className = 'tres';
        break;
      }
      case (grados > 56 && grados <= 79): {
        className = 'cuatro';
        break;
      }
      case (grados > 79 && grados <= 101): {
        className = 'cinco';
        break;
      }
      case (grados > 101 && grados <= 124): {
        className = 'seis';
        break;
      }
      case (grados > 124 && grados <= 146): {
        className = 'siete';
        break;
      }
      case (grados > 146 && grados <= 169): {
        className = 'ocho';
        break;
      }
      case (grados > 169 && grados <= 191): {
        className = 'nueve';
        break;
      }
      case (grados > 191 && grados <= 214): {
        className = 'diez';
        break;
      }
      case (grados > 214 && grados <= 236): {
        className = 'once';
        break;
      }
      case (grados > 236 && grados <= 259): {
        className = 'doce';
        break;
      }
      case (grados > 259 && grados <= 281): {
        className = 'trece';
        break;
      }
      case (grados > 281 && grados <= 304): {
        className = 'catorce';
        break;
      }
      case (grados > 304 && grados <= 326): {
        className = 'quince';
        break;
      }
      case (grados > 326 && grados <= 349): {
        className = 'dieciseis';
        break;
      }

    }
    return className;

  }
  /**
    * Cuando se da clic en icono de info
    * cierra o abre segun su estado de la barra de información
    * @param imei Identificador de unidad
  **/
  cerrarAbrirInfo(imei) {

    if (this.dispositivo[imei].visible === false) {
      return false;
    }

    this.dispositivo[imei].streetview = null;
    if ($('#info').find('i.tache').hasClass('fa-times-circle')) {
      document.getElementById('info').style.bottom = '-185px';

      $('#info').find('i.tache').removeClass('fa-times-circle').addClass('fa-info-circle');
    } else {
      document.getElementById('info').style.bottom = '0px';
      this.obtenerDireccion(this.dispositivo[imei].posicion.Latitude, this.dispositivo[imei].posicion.Longitude, imei);

      this.divInformacion = this.dispositivo[imei];

      this.formModel = {
        fechastart: moment().format('YYYY-MM-DD'),
        horastart: '00:00',
        fechaend: moment().format('YYYY-MM-DD'),
        horaend: moment().format('HH:mm')
      };
      $('#info').find('i.tache').removeClass('fa-info-circle').addClass('fa-times-circle');
      this.streetView(imei);
    }
  }
  /**
    * Abrir la barra de información de la unidad
    * @param imei Identificador de unidad
  **/
  abrirInfo(imei) {

    if (this.dispositivo[imei].visible === false) {
      return false;
    }

    this.obtenerDireccion(this.dispositivo[imei].posicion.Latitude, this.dispositivo[imei].posicion.Longitude, imei);

    this.divInformacion = this.dispositivo[imei];

    this.formModel = {
      fechastart: moment().format('YYYY-MM-DD'),
      horastart: '00:00',
      fechaend: moment().format('YYYY-MM-DD'),
      horaend: moment().format('HH:mm')
    };

    this.dispositivo[imei].streetview = null;

    $('#info').css('background-color', '#f7f78b');
    setTimeout(function () {
      $('#info').css('background-color', '#fff');
    }, 500);

    document.getElementById('info').style.bottom = '0px';
    $('#info').find('i.tache').removeClass('fa-info-circle').addClass('fa-times-circle');
    this.streetView(imei);
  }
  /**
    * Cerrar la barra de información de la unidad
    * @param imei Identificador de unidad
  **/
  cerrarInfo(imei) {
    this.dispositivo[imei].streetview = null;
    document.getElementById('info').style.bottom = '-185px';
    $('#info').find('i.tache').removeClass('fa-times-circle').addClass('fa-info-circle');
    this.divInformacion = [];
  }
  /**
    * Visualizar streetView de la unidad
    * @param imei Identificador de unidad
  **/
  streetView(imei) {

    this.dispositivo[imei].streetview = new google.maps.StreetViewPanorama(
      document.getElementById('streetview'), {
        position: { lat: parseFloat(this.dispositivo[imei].posicion.Latitude), lng: parseFloat(this.dispositivo[imei].posicion.Longitude) },
        panControl: false,
        zoomControl: false,
        addressControl: false,
        fullscreenControl: false,
        motionTrackingControl: false,
        linksControl: false
      });
  }
  /**
    * Para filtrar la busqueda de unidad
    * @param nombre Alias de la unidad
  **/
  filtrar(nombre) {
    if (this.filtro === '') {
      return true;
    }

    if (nombre.toLowerCase().indexOf(this.filtro.toLowerCase()) === -1) {
      return false;
    } else {
      return true;
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }
  /**
    * Pra mostrar el tiempo que lleva sin reportar el gps
    * @param nombre Fecha de ultimo reporte
    * @param imei Identificador de unidad
  **/
  diferenciaTiempo(tiempo, imei) {
    let cantidad;
    const now = moment([]);
    let time;

    if ((cantidad = (now.diff(tiempo, 'years'))) > 0) {
      if (cantidad === 1) {
        time = 'Hace ' + cantidad + ' año.';
      } else {
        time = 'Hace ' + cantidad + ' años.';
      }
    } else if ((cantidad = (now.diff(tiempo, 'months'))) > 0) {
      time = 'Hace ' + cantidad + ' m';
    } else if ((cantidad = (now.diff(tiempo, 'days'))) > 0) {
      this.dispositivo[imei].estatus = 'error';
      time = 'Hace ' + cantidad + ' d';
    } else if ((cantidad = (now.diff(tiempo, 'hours'))) > 0) {
      time = 'Hace ' + cantidad + ' h';
      this.dispositivo[imei].estatus = 'offline';
    } else if ((cantidad = (now.diff(tiempo, 'minutes'))) > 0) {
      this.dispositivo[imei].estatus = 'online';
      time = 'Hace ' + cantidad + ' min';
    } else if ((cantidad = (now.diff(tiempo, 'seconds'))) >= 0) {
      time = 'Hace unos segundos';
    } else {
      time = '-';
    }

    return time;
  }
  // Funciones para Reportes
  /**
   * Nos trae todos los datos para poder generar el reporte,
   * validando la fecha y hora.
   * @param fechastart Fecha comienza el reporte
   * @param horastart Hora comienza el reporte
   * @param fechaend Fecha termina el reporte
   * @param horaend Hora termina el reporte
   * @param markersRecorrido Todos los puntos del reprte
   * @param markersMovimiento Los puntos que reportan en movimiento
   * @param markersParadaMayor Los puntos que reportan en Parada mayor a 3 min
   * @param markersParadaMenor Los puntos que reportan en parada menor a 3 min
   * @param markersEstacionado Los puntos que reportan Estacionados
   * @param limites Centrar mapa con todos los puntos
   * @param polyline La linea que conecta todos los puntos
   * @param divReportes Donde se almacena todo los datos del reporte
   * @param datosXls enviar datos para generar archivo xml
   * @param imei Identificador de unidad
  **/
  recorridos(imei) {

    this.errorFechas = null;
    // tslint:disable-next-line:max-line-length
    if (((this.formModel.fechastart == null || this.formModel.horastart == null) || (this.formModel.fechastart.length !== 10 || this.formModel.horastart.length !== 5)) || (this.formModel.fechaend == null || this.formModel.horaend == null) || (this.formModel.fechaend.length !== 10 || this.formModel.horaend.length !== 5)) {
      swal('¡Oh no!', 'Todos los campos son requeridos.', 'error');
    } else {
      const recstart = moment(this.formModel.fechastart + ' ' + this.formModel.horastart).format('YYYY-MM-DD HH:mm:00');
      const recend = moment(this.formModel.fechaend + ' ' + this.formModel.horaend).format('YYYY-MM-DD HH:mm:59');
      if ((moment(recstart, 'YYYY-MM-DD HH:mm:ss').isSameOrBefore(recend, 'YYYY-MM-DD HH:mm:ss')) === false) {
        swal('¡Oh no!', 'La fecha final debe ser mayor a la de inicio.', 'error');
      } else {
        this.spinner.show();
        this.gps.recorrido(imei, recstart, recend).toPromise().then(data => {
          const temporalArray = [];
          const posicionPoli: Array<any> = [];
          const tds: Array<any> = [];
          const _markersRecorrido = this.markersRecorrido;
          const _markersMovimiento = this.markersMovimiento;
          const _markersParadaMenor = this.markersParadaMenor;
          const _markersParadaMayor = this.markersParadaMayor;
          const _markersEstacionado = this.markersEstacionado;
          const _markersTodos = this.markersTodos;
          const limites = new L.latLngBounds();
          const _gpsService = this.gps;
          let consumoAprox = 0;
          const indiceUnidad = this.listadoUnidades.map(x => x.imei).indexOf(imei);
          const _listadoUnidades = this.listadoUnidades;

          if (data.length > 0) {

            let temporalLat = null, temporalLng = null, fechainIcio = null, ix = 0, emtxt = 0;
            data.forEach(function (document) {
              // tslint:disable-next-line:max-line-length
              if ((document.trama.Latitude.length >= 9 && document.trama.Latitude.length <= 11) && (document.trama.Longitude.length >= 10 && document.trama.Longitude.length <= 12) && document.fecha.length === 24) {
                if (document.trama.Latitude !== temporalLat && document.trama.Longitude !== temporalLng) {
                  emtxt = 0;
                  temporalArray[ix] = [];
                  temporalArray[ix]['paro'] = '';
                  temporalLat = document.trama.Latitude;
                  temporalLng = document.trama.Longitude;
                  if (ix > 0 && temporalArray[ix - 1]['fechaFinal'] !== undefined) {
                    temporalArray[ix - 1]['fechaFinal'] = moment(document.fecha).format('DD-MM-YYYY HH:mm:ss');
                    emtxt = 1;
                  }
                  temporalArray[ix]['trama'] = document.trama;
                  temporalArray[ix]['fecha'] = moment(document.fecha).format('DD-MM-YYYY HH:mm:ss');
                  temporalArray[ix]['direccion'] = document.direccion;
                  /***** Datos de Trama *****/
                  // Nivel Bateria
                  if (document.trama.BackupBatteryPorcentage !== undefined) {
                    temporalArray[ix]['bateria'] = parseInt(document.trama.BackupBatteryPorcentage) + '%';
                  }
                  // Paro de motor & Estado de movimiento
                  if (document.trama.DeviceStatus !== undefined && document.trama.DeviceStatus.length === 6) {
                    if (emtxt === 0) {
                      switch (document.trama.DeviceStatus.substr(0, 2)) {
                        case '16':
                          temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y remolcado';
                          break;
                        case '1A':
                          temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y podría ser remolcado';
                          break;
                        case '11':
                          temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y está inmóvil';
                          break;
                        case '12':
                          temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y se está moviendo antes de ser tratado como remolcado';
                          break;
                        case '21':
                          temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está encendido y tiene menos movimiento';
                          break;
                        case '22':
                          temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está encendido y se está moviendo';
                          break;
                        case '41':
                          temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está inmóvil sin que se detecte una señal de encendido';
                          break;
                        case '42':
                          temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo se está moviendo sin que se detecte una señal de encendido.';
                          break;

                        default:
                          break;
                      }
                    }
                    // Estado paro de motor
                    if (document.trama.DeviceStatus.substring(5, 6) === '2') {
                      temporalArray[ix]['paro'] = 'Activado';
                    } else if (document.trama.DeviceStatus.substring(5, 6) === '0' && temporalArray[ix]['paro'] !== 'Activado') {
                      temporalArray[ix]['paro'] = 'Desactivado';
                    }
                  }
                  // Estado de movimiento
                  if (document.trama.State !== undefined && emtxt === 0) {
                    switch (document.trama.State) {
                      case '16':
                        temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y remolcado';
                        break;
                      case '1A':
                        temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y podría ser remolcado';
                        break;
                      case '11':
                        temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y está inmóvil';
                        break;
                      case '12':
                        temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y se está moviendo antes de ser tratado como remolcado';
                        break;
                      case '21':
                        temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está encendido y tiene menos movimiento';
                        break;
                      case '22':
                        temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está encendido y se está moviendo';
                        break;
                      case '41':
                        temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo está inmóvil sin que se detecte una señal de encendido';
                        break;
                      case '42':
                        temporalArray[ix]['estadomovimiento'] = 'El vehículo conectado al dispositivo se está moviendo sin que se detecte una señal de encendido.';
                        break;
                    }
                  }
                  // Paro de Motor
                  if (document.trama.DigitalOutput !== undefined && temporalArray[ix]['paro'] !== 'Activado') {
                    if (document.trama.DigitalOutput === '02' || document.trama.DigitalOutput === '01') {
                      temporalArray[ix]['paro'] = 'Activado';
                    } else if (document.trama.DigitalOutput === '00') {
                      temporalArray[ix]['paro'] = 'Desactivado';
                    }
                  }
                  // Voltaje Externo
                  if (document.trama.ExternalPowerVoltage !== undefined) {
                    temporalArray[ix]['voltaje'] = (parseInt(document.trama.ExternalPowerVoltage) / 1000) + 'V.';
                  }
                  // Kilometraje
                  if (document.trama.Mileage !== undefined) {
                    temporalArray[ix]['Mileage'] = document.trama.Mileage;
                  }
                  /***** Datos de Trama *****/
                  ix++;
                } else {
                  temporalArray[ix - 1]['fechaFinal'] = moment(document.fecha).format('DD-MM-YYYY HH:mm:ss');
                  /***** Datos de Trama *****/
                  // Nivel Bateria
                  if (document.trama.BackupBatteryPorcentage !== undefined) {
                    temporalArray[ix - 1]['bateria'] = parseInt(document.trama.BackupBatteryPorcentage) + '%';
                  }
                  // Paro de motor & Estado de movimiento
                  if (document.trama.DeviceStatus !== undefined && document.trama.DeviceStatus.length === 6) {
                    // Estado de movimiento
                    if (document.trama.DeviceStatus.substr(0, 2) === 16) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y remolcado';
                    } else if (document.trama.DeviceStatus.substr(0, 2) === '1A') {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y podría ser remolcado';
                    } else if (document.trama.DeviceStatus.substr(0, 2) === 11) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y está inmóvil';
                    } else if (document.trama.DeviceStatus.substr(0, 2) === 12) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y se está moviendo antes de ser tratado como remolcado';
                    } else if (document.trama.DeviceStatus.substr(0, 2) === 21) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está encendido y tiene menos movimiento';
                    } else if (document.trama.DeviceStatus.substr(0, 2) === 22) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está encendido y se está moviendo';
                    } else if (document.trama.DeviceStatus.substr(0, 2) === 41) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está inmóvil sin que se detecte una señal de encendido';
                    } else if (document.trama.DeviceStatus.substr(0, 2) === 42) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo se está moviendo sin que se detecte una señal de encendido.';
                    }
                    // Paro de motor
                    if (document.trama.DeviceStatus.substring(5, 6) === '2') {
                      temporalArray[ix - 1]['paro'] = 'Activado';
                    } else if (document.trama.DeviceStatus.substring(5, 6) === '0' && temporalArray[ix - 1]['paro'] !== 'Activado') {
                      temporalArray[ix - 1]['paro'] = 'Desactivado';
                    }

                  }
                  // Estado de movimiento
                  if (document.trama.State !== undefined) {
                    if (document.trama.State === 16) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y remolcado';
                    } else if (document.trama.State === '1A') {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y podría ser remolcado';
                    } else if (document.trama.State === 11) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y está inmóvil';
                    } else if (document.trama.State === 12) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está apagado y se está moviendo antes de ser tratado como remolcado';
                    } else if (document.trama.State === 21) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está encendido y tiene menos movimiento';
                    } else if (document.trama.State === 22) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está encendido y se está moviendo';
                    } else if (document.trama.State === 41) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo está inmóvil sin que se detecte una señal de encendido';
                    } else if (document.trama.State === 42) {
                      temporalArray[ix - 1]['estadomovimiento'] = 'El vehículo conectado al dispositivo se está moviendo sin que se detecte una señal de encendido.';
                    }
                  }
                  // Paro de Motor
                  if (document.trama.DigitalOutput !== undefined && temporalArray[ix - 1]['paro'] !== 'Activado') {
                    if (document.trama.DigitalOutput === '02' || document.trama.DigitalOutput === '01') {
                      temporalArray[ix - 1]['paro'] = 'Activado';
                    } else if (document.trama.DigitalOutput === '00') {
                      temporalArray[ix - 1]['paro'] = 'Desactivado';
                    }
                  }
                  // Voltaje Externo
                  if (document.trama.ExternalPowerVoltage !== undefined) {
                    temporalArray[ix - 1]['voltaje'] = (parseInt(document.trama.ExternalPowerVoltage) / 1000) + 'V.';
                  }
                  // Kilometraje
                  if (document.trama.Mileage !== undefined) {
                    temporalArray[ix - 1]['Mileage'] = document.trama.Mileage;
                  }
                  /***** Datos de Trama *****/
                }
              }
            });

            let velocidadTotal = 0, mileage = 0, velocidad = null;
            let iVel = 0;
            let datosinfo = '';
            let px = 1, resta = 0, guarda = null, mP = 0, sP = 0, dE = 0, hE = 0, mE = 0, sE = 0;
            const _map = this.map;
            const nombre = this.dispositivo[imei].alias;

            temporalArray.forEach(function (param) {

              fechainIcio = null;
              let fechaFinal = null, beautifyOptions, tipoMarker = null, colorMarker = null, fechainfo = '', diferencia = '', menor = null, mayor = null, tiempo = '';
              if (param.fechaFinal === undefined) {
                velocidad = param.trama.Speed !== undefined ? param.trama.Speed : '0.0';
                datosinfo = '<tr><td><strong>Fecha:</strong> ' + param.fecha + '</td></tr><tr><td style="border:none;"><strong>Movimiento</strong></td></tr><tr><td style="border:none;"><strong>Vel.:</strong> ' + velocidad + ' Km/h</td></tr>';
                fechainfo = param.fecha;
                tiempo = 'Movimiento, Vel. ' + velocidad + ' Km/h';
                tipoMarker = 'movimiento';
                beautifyOptions = { iconShape: 'circle-dot', borderWidth: 5 };
                velocidadTotal = velocidadTotal + parseFloat(velocidad);
                iVel++;
              } else {
                fechainIcio = moment(param.fecha, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD');
                fechaFinal = moment(param.fechaFinal, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD');
                if (moment(fechainIcio).isSame(fechaFinal)) {
                  fechainfo = param.fecha + ' - ' + moment(param.fechaFinal, 'DD-MM-YYYY HH:mm:ss').format('HH:mm:ss');
                } else {
                  fechainfo = param.fecha + ' a ' + param.fechaFinal;
                }
                fechainIcio = moment(param.fecha, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                fechaFinal = moment(param.fechaFinal, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                const resultadoDiff = moment(fechaFinal).diff(fechainIcio, 'seconds');
                const dias = Math.floor(resultadoDiff / 86400);
                const horas = Math.floor((resultadoDiff - (dias * 86400)) / 3600);
                const minutos = Math.floor((resultadoDiff - (dias * 86400) - (horas * 3600)) / 60);
                const segundos = resultadoDiff - (dias * 86400) - (horas * 3600) - (minutos * 60);
                const juntar = horas + ':' + minutos + ':' + segundos;
                menor = moment('0:3:0', 'HH:mm:ss');
                mayor = moment('0:5:0', 'HH:mm:ss');
                if (moment(juntar, 'HH:mm:ss').isSameOrBefore(mayor)) {
                  if (minutos !== 0) {
                    diferencia += minutos + ' min ';
                    mP = mP + minutos;
                  }
                  if (segundos !== 0) {
                    diferencia += segundos + ' s';
                    sP = sP + segundos;
                  }
                  if (minutos === 0 && segundos === 0) {
                    diferencia = '0 s';
                  }
                  tipoMarker = (moment(juntar, 'HH:mm:ss').isSameOrBefore(menor)) ? 'parada-menor' : 'parada-mayor';
                  tiempo = 'Parada ' + diferencia;
                  colorMarker = (moment(juntar, 'HH:mm:ss').isSameOrBefore(menor)) ? '#ffc107' : '#ff9207';
                } else {
                  colorMarker = 'red';
                  tipoMarker = 'estacionado';
                  if (dias !== 0) {
                    diferencia += dias + ' d ';
                    dE = dE + dias;
                  }
                  if (horas !== 0) {
                    diferencia += horas + ' h ';
                    hE = hE + horas;
                  }
                  if (minutos !== 0) {
                    diferencia += minutos + ' min ';
                    mE = mE + minutos;
                  }
                  if (segundos !== 0) {
                    diferencia += segundos + ' s';
                    sE = sE + segundos;
                  }
                  tiempo = 'Estacionado ' + diferencia;
                }
                datosinfo = '<tr><td colspan="3"><strong>Fecha:</strong> ' + fechainfo + '</td></tr><tr><td colspan="3" style="border:none;">' + tiempo + '</td></tr>';
                beautifyOptions = {
                  iconShape: 'circle-dot',
                  borderWidth: 5,
                  borderColor: colorMarker,
                  innerIconStyle: 'margin-top:0;'
                };
              }

              posicionPoli.push({ lat: parseFloat(param.trama.Latitude), lng: parseFloat(param.trama.Longitude) });

              _markersRecorrido[px] = L.marker(
                [param.trama.Latitude, param.trama.Longitude],
                { icon: L.BeautifyIcon.icon(beautifyOptions) }
              );
              _markersRecorrido[px].bindTooltip('<div class="InfoWindow" id="InfoWindow' + px + '"><h1 class="firstHeading text-center">Posición ' + px + '</h1><div class="bodyContent"><table class="table table-sm"><tbody>' + datosinfo + '</tbody></table></div></div>');
              _markersTodos.addLayer(_markersRecorrido[px]);

              if (tipoMarker === 'movimiento') {
                _markersMovimiento.addLayer(_markersRecorrido[px]);
              } else if (tipoMarker === 'parada-menor') {
                _markersParadaMenor.addLayer(_markersRecorrido[px]);
              } else if (tipoMarker === 'parada-mayor') {
                _markersParadaMayor.addLayer(_markersRecorrido[px]);
              } else {
                _markersEstacionado.addLayer(_markersRecorrido[px]);
              }

              limites.extend(L.latLng(param.trama.Latitude, param.trama.Longitude));
              _map.fitBounds(limites);
              // Kilometraje
              if (param.Mileage !== undefined) {
                if (resta === 0) {
                  resta = 1;
                  guarda = parseFloat(param.Mileage);
                } else {
                  if (parseFloat(param.Mileage) > guarda) {
                    mileage = (parseFloat(param.Mileage) - parseFloat(guarda));
                    if (_listadoUnidades[indiceUnidad].consumo !== ' --- ') {
                      consumoAprox = mileage / parseFloat(_listadoUnidades[indiceUnidad].consumo);
                    }
                  }
                }
              }
              tds.push({
                Punto: px++,
                Nombre: nombre,
                Tipo: tipoMarker,
                Fecha: fechainfo,
                Tiempo: tiempo,
                Latitude: param.trama.Latitude,
                Longitude: param.trama.Longitude,
                // @ts-ignore
                Direccion: 'Precesando...',
                Kilometraje: mileage.toFixed(2),
                Consumo: consumoAprox.toFixed(2) + ' L',
                Bateria: (param.bateria !== undefined) ? param.bateria : '---',
                Estado: (param.estadomovimiento !== undefined) ? param.estadomovimiento : 'Sin información',
                ParoMotor: (param.paro !== undefined) ? param.paro : 'Sin información',
                Voltaje: (param.voltaje !== undefined) ? param.voltaje : '---',
                Mapa: 'https://www.google.com/maps/search/?api=1&query=' + param.trama.Latitude + ',' + param.trama.Longitude,
              });

              _gpsService.direccion(param.trama.Latitude, param.trama.Longitude, px - 1).toPromise().then(data => {
                // @ts-ignore
                tds[tds.map(x => x.Punto).indexOf(data.punto)].Direccion = data.result[0].formatedFull;
              });

            });

            this.displayedmarkers = _markersTodos;
            this.markersRecorrido = _markersRecorrido;
            _map.addLayer(this.displayedmarkers);
            this.polyline = L.polyline(posicionPoli, {
              color: '#5897e2b0',
              opacity: 0.7,
              weight: 10,
              noClip: true,
              lineJoin: 'round'
            }).addTo(_map);
            this.polyline.setText('\u25BA', {
              repeat: true,
              offset: 6,
              attributes: {
                fill: '#3030d2e6'
              }
            });
            this.datosXls = tds;
            this.divReportes['recorridoimei'] = imei;
            this.divReportes['alias'] = this.dispositivo[imei].alias;
            this.divReportes['recstart'] = recstart;
            this.divReportes['recend'] = recend;
            this.divReportes['tds'] = tds;
            this.divReportes['TotalParada'] = this.trasform_time(sP, mP);
            this.divReportes['totalEstacionado'] = this.trasform_time(sE, mE, hE, dE);
            this.divReportes['TotalVelocidad'] = (velocidadTotal === 0 && iVel === 0) ? 0 : Math.round(velocidadTotal / iVel);
            document.getElementById('tablaReportes').style.bottom = '0px';
            document.getElementById('cerrarRep').style.display = 'block';
          } else {
            swal({
              title: 'No hay resultados a mostrar.',
              icon: 'error',
            });
          }
          this.spinner.hide();
          this.errorFechas = null;
        });
      }

    }
  }
  /**
   * Saber el tiempo total en estacionadas o paradas todo se envia en segundos
   * @param s Segundos
   * @param m Minutos
   * @param h horas
   * @param d Dias
  **/
  trasform_time(s = 0, m = 0, h = 0, d = 0) {
    const tiempo_en_segundos = (d * 86400) + (h * 3600) + (m * 60) + s;
    const dias = Math.floor(tiempo_en_segundos / 86400);
    const horas = Math.floor((tiempo_en_segundos - (dias * 86400)) / 3600);
    const minutos = Math.floor((tiempo_en_segundos - (dias * 86400) - (horas * 3600)) / 60);
    const segundos = tiempo_en_segundos - (dias * 86400) - (horas * 3600) - (minutos * 60);
    let tiempo_total = '';
    if (dias > 0) {
      tiempo_total += dias + ' d ';
    }
    if (horas > 0) {
      tiempo_total += horas + ' h ';
    }
    if (minutos > 0) {
      tiempo_total += minutos + ' min ';
    }
    if (segundos > 0) {
      tiempo_total += segundos + 's';
    }
    if (dias === 0 && horas === 0 && minutos === 0 && segundos === 0) {
      tiempo_total = '0';
    }
    return tiempo_total;
  }
  /**
   * Centra mapa al seleccionar un punto
   * @param num_marker Identificador del punto
  **/
  selectMarker(num_marker) {
    this.markersRecorrido[num_marker].openTooltip();
    this.map.fitBounds(L.latLngBounds([this.markersRecorrido[num_marker].getLatLng()]));
  }
  /**
   * Filtran los puntos por las diferentes opciones todos, moviemiento,
   * paradas menor a 3 min, paradas mayor a 3 min, estacionadas
  **/
  filterMarkers() {
    if (this.selecTipo === 'todos') {
      $('.txt-datos').closest('tr').show();
    } else {
      $('.txt-datos').closest('tr').hide();
      $('.' + this.selecTipo).closest('tr').show();
    }
    this.map.removeLayer(this.displayedmarkers);
    if (this.selecTipo === 'todos') {
      this.displayedmarkers = this.markersTodos;
    } else if (this.selecTipo === 'movimiento') {
      this.displayedmarkers = this.markersMovimiento;
    } else if (this.selecTipo === 'parada-menor') {
      this.displayedmarkers = this.markersParadaMenor;
    } else if (this.selecTipo === 'parada-mayor') {
      this.displayedmarkers = this.markersParadaMayor;
    } else {
      this.displayedmarkers = this.markersEstacionado;
    }
    this.map.addLayer(this.displayedmarkers);
  }
  /**
   * Cierra la barra de reportes y vacia las variblaes
   * que se utilizaron, elimina del mapa la capa de markers y polyline
  **/
  cerrardivReportes() {
    // this.map.removeLayer(this.markersTodos);
    this.markersTodos.clearLayers();
    this.map.removeLayer(this.markersMovimiento);
    this.map.removeLayer(this.markersParadaMenor);
    this.map.removeLayer(this.markersParadaMayor);
    this.map.removeLayer(this.markersEstacionado);
    this.map.removeLayer(this.displayedmarkers);
    this.map.removeLayer(this.polyline);
    this.map.removeLayer(this.polylineDecora);
    this.markersRecorrido = [];
    this.divReportes = [];
    document.getElementById('tablaReportes').style.bottom = '-250px';
    document.getElementById('cerrarRep').style.display = 'none';
  }
  /**
   * Imprimir reporte con el mapa, los puntos
   * y la linea trazada uniendo los puntos
   * @param imei Identificador de GPS
  **/
  imprimir(imei) {
    const antes = { target: { checked: false } };
    const despues = { target: { checked: true } };
    this.checkFuncionAll(antes);
    this.dispositivo[imei].visible = true;
    this.map.addLayer(this.dispositivo[imei].marker);
    window.print();
    this.checkFuncionAll(despues);
    this.abrirInfo(imei);
  }
  // Funciones para Operadors
  /**
   * Abre la ventana donde se muestra los operadores
  **/
  verOperadores() {
    document.getElementById('ventanOperador').classList.add('abrir');
  }
  /**
   * Cierra la ventana donde se muestran los operadores
  **/
  cerrarOperadores() {
    document.getElementById('ventanOperador').classList.remove('abrir');
  }
  /**
   * Hace que el campo solo acepte letras y espacios unicamente
   * @param e evento de presionar las teclas
  **/
  soloLetras(e) {
    const key = e.keyCode || e.which;
    const tecla = String.fromCharCode(key).toLowerCase();
    const letras = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyzÁÉÍÓÚáéíóúÜü ';
    const especiales = [8, 37, 39, 46];
    let tecla_especial = false;
    for (const i in especiales) {
      if (key === especiales[i]) {
        tecla_especial = true;
        break;
      }
    }
    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
      return false;
    }
  }
  /**
   * Hace que el campo solo acepte numeros.
   * @param e evento de presionar las teclas
  **/
  soloNumeros(e) {
    const key = e.keyCode || e.which;
    const tecla = String.fromCharCode(key).toLowerCase();
    const letras = '1234567890';
    const especiales = [8, 37, 39, 46];
    let tecla_especial = false;
    for (const i in especiales) {
      if (key === especiales[i]) {
        tecla_especial = true;
        break;
      }
    }
    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
      return false;
    }
  }
  /**
   * Hace que el campo solo acepte numeros y punto.
   * @param e evento de presionar las teclas
  **/
  puntoNumeros(e) {
    const key = e.keyCode || e.which;
    const tecla = String.fromCharCode(key).toLowerCase();
    const letras = '1234567890.';
    const especiales = [8, 37, 39, 46];
    let tecla_especial = false;
    for (const i in especiales) {
      if (key === especiales[i]) {
        tecla_especial = true;
        break;
      }
    }
    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
      return false;
    }
  }
  /**
   * Prepara las variables para su uso en el modal
   * de nuevo operador, tambien para los errores
   * @param model que contien:
   * @param newnombre Nombre(s) del operador
   * @param newpaterno Apellido paterno
   * @param newmaterno Apellido maternp
   * @param newempleado Numero de empleado
   * @param newlicencia Numero de licencia
   * @param newfecha Vigencia de la licencia
  **/
  modalNuevoOperador() {
    this.model = {};
    this.model = {
      newnombre: '',
      newpaterno: '',
      newmaterno: '',
      newempleado: '',
      newlicencia: '',
      newfecha: ''
    };
    $('#nuevo_nombremailHelp').html('');
    $('#nuevo_paternoHelp').html('');
    $('#nuevo_maternoHelp').html('');
    $('#nuevoempleadoHelp').html('');
    $('#nuevolicenciaHelp').html('');
    $('#nuevofechaHelp').html('');
  }
  /**
   * Valida los datos ingresados por el usuario para ola creacion del operador
   * @param newnombre Nombre(s) del operador
   * @param newpaterno Apellido paterno
   * @param newmaterno Apellido maternp
   * @param newempleado Numero de empleado
   * @param newlicencia Numero de licencia
   * @param newfecha Vigencia de la licencia
  **/
  nuevoOperador() {
    let errornombre = null, errorpaterno = null, errormaterno = null, errorlicencia = null, errorempleado = null, errorfecha = null, nuevoempleado;
    if (this.model.newnombre.length === 0 || this.model.newnombre === '') {
      errornombre = 'Campo obligatorio';
    }
    if (this.model.newpaterno.length === 0 || this.model.newpaterno === '') {
      errorpaterno = 'Campo obligatorio';
    }
    if (this.model.newmaterno.length === 0 || this.model.newmaterno === '') {
      errormaterno = 'Campo obligatorio';
    }
    if (this.model.newempleado === '' || this.model.newempleado.length === 0) {
      nuevoempleado = null;
    } else {
      if (!isNaN(parseInt(this.model.newempleado))) {
        nuevoempleado = this.model.newempleado;
      } else {
        errorempleado = 'Campo debe contener solo números';
      }
    }
    if (this.model.newlicencia.length === 0 || this.model.newlicencia === '') {
      errorlicencia = 'Campo obligatorio';
    } else if (this.model.newlicencia.length < 12 || this.model.newlicencia.length > 15) {
      errorlicencia = 'Campo de contener de 12 a 15 caracteres';
    } else {
      let indexOperador = -1;
      indexOperador = this.listadoOperadores.map(x => x.licencia).indexOf(this.model.newlicencia);
      if (indexOperador !== -1) {
        errorlicencia = 'Campo debe ser unico.';
      }
    }
    if (this.model.newfecha.length === 0 || this.model.newfecha === '') {
      errorfecha = 'Campo obligatorio';
    }
    if (errornombre == null && errorpaterno == null && errormaterno == null && errorempleado == null && errorlicencia == null && errorfecha == null) {
      const datos = '\nNombre: ' + this.model.newnombre +
        '\nApellido Paterno: ' + this.model.newpaterno +
        '\nApellido Paterno: ' + this.model.newmaterno +
        '\nN. Empleado: ' + nuevoempleado +
        '\nN. Licencia: ' + this.model.newlicencia +
        '\nN. Vigencia de licencia: ' + moment(this.model.newfecha, 'YYYY-MM-DD').format('DD-MM-YYYY');
      swal({
        title: '¡Nuevo Operador!',
        text: 'Se creara con los siguientes datos:' + datos + '\n¿Deseas crear al operador?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CREAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'CREAR') {
              swal('¡Error!', 'No se ha escrito \'CREAR\' correctamente', 'error');
            } else {
              this.operadoresService.nuevOperador(this.model.newnombre, this.model.newpaterno, this.model.newmaterno, nuevoempleado, this.model.newlicencia, this.model.newfecha).toPromise().then(data => {
                if (data.length > 0) {
                  $('#nuevooperador').modal('hide');
                  const epleadotd = (data[0].empleado == null) ? ' --- ' : data[0].empleado;
                  // $('#tableOperadores > tbody').append('<tr id="operador'+data[0].uid+'" role="row"><th scope="row" class="sorting_1">'+data[0].uid+'</th><td>'+data[0].nombre+' '+data[0].paterno+' '+data[0].materno+'</td><td>'+epleadotd+'</td><td>'+data[0].licencia+'</td><td><button class="btn btn-primary btn-sm btonesO" (click)="editarOperador('+data[0].uid+')" data-toggle="modal" data-target="#editaroperadores" style="padding: 0.1rem .3rem;margin-right: 3px;">Editar</button><button class="btn btn-danger btn-sm btonesO" (click)="editarOperador('+data[0].uid+')" style="padding: 0.1rem .3rem;margin-right: 3px;">Eliminar</button><button class="btn btn-warning btn-sm" (click)="historicoOperdaores('+data[0].uid+')" data-fancybox data-src="#historialOperador" data-modal="true" href="javascript:;" style="padding: 0.1rem .3rem;">Historial</button></td></tr>');
                  const dateNow = moment();
                  let faltan = ' --- ', clase = '';
                  const fechaAvisar = moment(data[0].vigencia, 'YYYY-MM-DD').subtract(30, 'days');
                  if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
                    faltan = 'Falta ' + moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
                  } else if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
                    faltan = 'Falta ' + moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
                  } else if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
                    faltan = 'Falta ' + moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
                  } else if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
                    faltan = 'Falta ' + moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
                  } else if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
                    faltan = 'Necesita ser renovada.';
                  } else {
                    faltan = 'Necesita ser renovada. Se ha pasado por ' + (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
                  }
                  if (dateNow.isBetween(fechaAvisar, data[0].vigencia)) {
                    clase = 'table-warning';
                  } else if (dateNow.isSameOrAfter(data[0].vigencia)) {
                    clase = 'table-danger';
                  }
                  this.listadoOperadores.push({
                    id: data[0].id,
                    uid: data[0].uid,
                    nombre: data[0].nombre,
                    paterno: data[0].paterno,
                    materno: data[0].materno,
                    empleado: epleadotd,
                    licencia: data[0].licencia,
                    vigencia: moment(data[0].vigencia, 'YYYY-MM-DD').format('DD-MM-YYYY'),
                    faltan: faltan,
                    clase: clase
                  });
                  swal('Se ha creado correctamente', {
                    icon: 'success',
                  });
                } else {
                  swal({
                    title: 'Hubo un error al crear un operador',
                    icon: 'error',
                    className: 'swalOperador',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });
    } else {
      $('#nuevo_nombremailHelp').html(errornombre);
      $('#nuevo_paternoHelp').html(errorpaterno);
      $('#nuevo_maternoHelp').html(errormaterno);
      $('#nuevoempleadoHelp').html(errorempleado);
      $('#nuevolicenciaHelp').html(errorlicencia);
      $('#nuevofechaHelp').html(errorfecha);
    }
  }
  /**
   * Prepara las variables para su uso en el modal
   * de editar operador cargando los datos, tambien para los errores
   * @param ename Nombre(s) del operador
   * @param epaterno Apellido paterno
   * @param ematerno Apellido maternp
   * @param eempleado Numero de empleado
   * @param elicencia Numero de licencia
   * @param evigencia Vigencia de la licencia
   * @param uid Identificador del operador
  **/
  modalediatar(uid) {
    this.model = {};
    const indiceOperador = this.listadoOperadores.map(x => x.uid).indexOf(uid);
    this.model = {
      ename: this.listadoOperadores[indiceOperador].nombre,
      epaterno: this.listadoOperadores[indiceOperador].paterno,
      ematerno: this.listadoOperadores[indiceOperador].materno,
      eempleado: (this.listadoOperadores[indiceOperador].empleado === ' --- ') ? null : this.listadoOperadores[indiceOperador].empleado,
      elicencia: this.listadoOperadores[indiceOperador].licencia,
      evigencia: moment(this.listadoOperadores[indiceOperador].vigencia, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      euid: uid,
      index: indiceOperador
    };
    $('#editarnombremailHelp').html('');
    $('#editarpaternoHelp').html('');
    $('#editarmaternoHelp').html('');
    $('#editarmpleadoHelp').html('');
    $('#editaricenciaHelp').html('');
    $('#editarfechaHelp').html('');
  }
  /**
   * Valida los datos ingresados por el usuario para la edicion
   * @param ename Nombre(s) del operador
   * @param epaterno Apellido paterno
   * @param ematerno Apellido maternp
   * @param eempleado Numero de empleado
   * @param elicencia Numero de licencia
   * @param evigencia Vigencia de la licencia
   * @param uid Identificador del operador
  **/
  editarOperador(uid) {
    let errornombre = null, errorpaterno = null, errormaterno = null, errorlicencia = null, errorempleado = null, errorfecha = null, nuevoempleado;
    if (this.model.ename === undefined || this.model.ename.length === 0) {
      errornombre = 'Campo obligatorio';
    }
    if (this.model.epaterno === undefined || this.model.epaterno.length === 0) {
      errorpaterno = 'Campo obligatorio';
    }
    if (this.model.ematerno === undefined || this.model.ematerno.length === 0) {
      errormaterno = 'Campo obligatorio';
    }
    if (this.model.eempleado === undefined || this.model.eempleado.length === 0) {
      nuevoempleado = null;
    } else {
      if (!isNaN(parseInt(this.model.eempleado))) {
        nuevoempleado = this.model.eempleado;
      } else {
        errorempleado = 'Campo debe contener solo números';
      }
    }
    if (this.model.elicencia === undefined || this.model.elicencia.length === 0) {
      errorlicencia = 'Campo obligatorio';
    } else if (this.model.elicencia.length < 12 || this.model.elicencia.length > 15) {
      errorlicencia = 'Campo de contener de 12 a 15 caracteres';
    } else {
      let indexOperador = -1;
      indexOperador = this.listadoOperadores.map(x => x.licencia).indexOf(this.model.elicencia);
      if (indexOperador !== -1 && this.model.index !== indexOperador) {
        errorlicencia = 'Campo debe ser unico.';
      }
    }
    if (this.model.evigencia.length === 0 || this.model.evigencia === '') {
      errorfecha = 'Campo obligatorio';
    }
    if (errornombre == null && errorpaterno == null && errormaterno == null && errorempleado == null && errorlicencia == null) {
      const datos = '\nNombre: ' + this.model.ename +
        '\nApellido Paterno: ' + this.model.epaterno +
        '\nApellido Paterno: ' + this.model.ematerno +
        '\nN. Empleado: ' + nuevoempleado +
        '\nN. Licencia: ' + this.model.elicencia +
        '\nN. Vigencia de licencia: ' + moment(this.model.evigencia, 'YYYY-MM-DD').format('DD-MM-YYYY');
      swal({
        title: '¡Editar Operador!',
        text: 'Se modificará con los siguientes datos:' + datos + '\n¿Deseas modificar al operador?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'EDITAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'EDITAR') {
              swal('¡Error!', 'No se ha escrito \'EDITAR\' correctamente', 'error');
            } else {
              const empleado = (this.model.eempleado == null || this.model.eempleado.length === 0) ? null : this.model.eempleado;
              this.operadoresService.actualizarOperador(this.model.ename, this.model.epaterno, this.model.ematerno, empleado, this.model.elicencia, this.model.evigencia, uid).toPromise().then(data => {
                if (data['affectedRows'] === 1 && data['warningCount'] === 0) {
                  const dateNow = moment();
                  let faltan = ' --- ', clase = '';
                  const fechaAvisar = moment(this.model.evigencia, 'YYYY-MM-DD').subtract(30, 'days');
                  if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
                    faltan = 'Falta ' + moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
                  } else if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
                    faltan = 'Falta ' + moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
                  } else if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
                    faltan = 'Falta ' + moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
                  } else if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
                    faltan = 'Falta ' + moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
                  } else if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
                    faltan = 'Necesita ser renovada.';
                  } else {
                    faltan = 'Necesita ser renovada. Se ha pasado por ' + (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
                  }
                  if (dateNow.isBetween(fechaAvisar, this.model.evigencia)) {
                    clase = 'table-warning';
                  } else if (dateNow.isSameOrAfter(this.model.evigencia)) {
                    clase = 'table-danger';
                  }
                  const eempleado = (this.model.eempleado == null || this.model.eempleado.length === 0) ? ' --- ' : this.model.eempleado;
                  this.listadoOperadores[this.model.index].nombre = this.model.ename;
                  this.listadoOperadores[this.model.index].paterno = this.model.epaterno;
                  this.listadoOperadores[this.model.index].materno = this.model.ematerno;
                  this.listadoOperadores[this.model.index].empleado = eempleado;
                  this.listadoOperadores[this.model.index].licencia = this.model.elicencia;
                  this.listadoOperadores[this.model.index].vigencia = moment(this.model.evigencia, 'YYYY-MM-DD').format('DD-MM-YYYY');
                  this.listadoOperadores[this.model.index].faltan = faltan;
                  this.listadoOperadores[this.model.index].clase = clase;
                  $('#editaroperadores').modal('hide');
                  swal('Se actualizo correctamente', {
                    icon: 'success',
                  });
                  // $("#operador"+uid).html('<th scope="row">'+uid+'</th><td>'+this.model.ename+' '+this.model.epaterno+' '+this.model.ematerno+'</td><td>'+eempleado+'</td><td>'+this.model.elicencia+'</td><td><button class="btn btn-primary btn-sm btonesO" (click)="editarOperador('+uid+')" data-toggle="modal" data-target="#editaroperadores" style="padding: 0.1rem .3rem;margin-right: 3px;">Editar</button> <button class="btn btn-danger btn-sm btonesO" (click)="editarOperador('+uid+')" style="padding: 0.1rem .3rem;margin-right: 3px;">Eliminar</button><button class="btn btn-warning btn-sm" style="padding: 0.1rem .3rem; ">Historial</button></td>');
                } else {
                  swal({
                    title: 'Hubo un error al editar el operador',
                    icon: 'error',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });

    } else {
      $('#editarnombremailHelp').html(errornombre);
      $('#editarpaternoHelp').html(errorpaterno);
      $('#editarmaternoHelp').html(errormaterno);
      $('#editarmpleadoHelp').html(errorempleado);
      $('#editaricenciaHelp').html(errorlicencia);
      $('#editarfechaHelp').html(errorfecha);
    }
  }
  /**
   * Se elimina el operador
   * @param uid Identificador del operador
  **/
  eliminarOperador(uid) {
    swal({
      title: '¿Deseas eliminar este operador?',
      icon: 'warning',
      className: 'swalOperador',
      buttons: {
        cancel: {
          text: 'Cancelar',
          value: false,
          visible: true,
          dangerMode: true,
          className: 'btn-danger'
        },
        confirm: {
          text: 'Eliminarlo',
          value: true,
          visible: true,
          className: 'btn-primary'
        }
      },
    }).then((willDelete) => {
      if (willDelete) {
        swal({
          text: 'Introduzca la palabra \'ELIMINAR\' para continuar',
          content: 'input',
          // @ts-ignore
          button: {
            text: 'Continuar',
            closeModal: false
          }
        }).then(value => {
          if (!value) { throw null; }
          if (value !== 'ELIMINAR') {
            swal('¡Error!', 'No se ha escrito \'ELIMINAR\' correctamente', 'error');
          } else {
            const indiceOperador = this.listadoOperadores.map(x => x.uid).indexOf(uid);
            this.operadoresService.eliminarOperador(this.listadoOperadores[indiceOperador].id).toPromise().then(data => {
              if (data.affectedRows === 1) {
                $('#operador' + uid).remove();
                // $("#operador"+uid).hide();
                // delete this.listadoOperadores[indiceOperador];
                this.listadoOperadores.splice(indiceOperador, 1);
                if ($('#tableOperadores > tbody')[0].children.length === 0) {
                  this.listadoOperadores = [];
                }
                swal('Se elimino correctamente', {
                  icon: 'success',
                });
              } else {
                let error = 'Hubo un error al eliminar';
                if (data.unidades !== undefined) {
                  error = data.unidades;
                }
                swal({
                  title: error,
                  icon: 'error',
                });
              }
            });
          }
        }).catch(error => {
          if (error) {
            swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
          } else {
            swal.stopLoading();
            // @ts-ignore
            swal.close();
          }
        });

      }
    });

  }
  /**
   * Historico de las unidades asignadas y de las incidencias
   * @param uid Identificador del operador
   * @param listadoIncidencias todas las asignaciones que ha tenido
   * @param listadoAsignacion todas las incidencias
  **/
  historicoOperdaores(uid) {
    this.historial = {};
    let arrayTemp: Array<any> = [];
    this.listadoAsignacion = [];
    this.listadoIncidencias = [];
    this.operadoresService.historialOperadores(uid).toPromise().then(data => {
      $('#asignadas-tab').tab('show');
      if (Object.entries(data.unidades).length > 0) {
        data.unidades.forEach(element => {
          arrayTemp.push({
            uid: element.uid,
            unidad: element.unidad,
            marca: element.marca,
            modelo: element.modelo,
            version: element.version,
            anio: element.anio,
            serie: element.serie,
            placas: element.placas,
            asignacion: moment(element.asignacion, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm'),
            termina: (element.activo === 1) ? ' Asignada actualmente ' : moment(element.termina, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm')
          });
        });
        this.listadoAsignacion = arrayTemp;
      }
      arrayTemp = [];
      if (Object.entries(data.incidencias).length > 0) {
        data.incidencias.forEach(element => {
          arrayTemp.push({
            uidIns: element.uidIns,
            uid: element.uid,
            unidad: element.unidad,
            placas: (element.placas == null) ? ' --- ' : element.placas,
            incidencia: element.incidencia,
            fecha: moment(element.fecha_incidencia, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm'),
            costo: element.costo,
            estatus: (element.estatus == null) ? 'Sin estatus' : element.estatus
          });
        });
        this.listadoIncidencias = arrayTemp;
      }
      const indiceOperador = this.listadoOperadores.map(x => x.uid).indexOf(uid);
      this.historial = {
        btn: 0,
        uidOperador: uid,
        nombre: this.listadoOperadores[indiceOperador].nombre + ' ' + this.listadoOperadores[indiceOperador].paterno + ' ' + this.listadoOperadores[indiceOperador].materno,
        indice: indiceOperador
      };

    });
  }
  /**
   * Cierra la venta de historial de operadores
   * las variables vuelven a estar vacias
  **/
  cerrarVentanaHistorial() {
    $('.incidencia' + this.historial.uidOperador).remove();
    this.historial = {};
    this.listadoAsignacion = [];
    this.listadoIncidencias = [];
  }
  /**
   * Prepara variables para nueva incidencia
   * @param uidUnidad Identificador de unidad
   * @param uidOperador Identificador de operador
   */
  modalNuevaIncidencia(uidUnidad = '', uidOperador = null) {
    this.model = {};
    let undadAlias = 'No hay unidad asignada';
    let indiceUnidad = -1;
    if ((Object.entries(this.historial).length === 0)) {
      this.historial = {};
      let indiceOperador = -1;
      indiceOperador = this.listadoOperadores.map(x => x.id).indexOf(uidOperador);
      if (indiceOperador === -1) {
        undadAlias = 'No hay operador asignado';
        uidUnidad = '';
        this.historial = { btn: 1 };
      } else {
        this.historial = {
          btn: 1,
          uidOperador: this.listadoOperadores[indiceOperador].uid,
          nombre: this.listadoOperadores[indiceOperador].nombre + ' ' + this.listadoOperadores[indiceOperador].paterno + ' ' + this.listadoOperadores[indiceOperador].materno,
          indice: indiceOperador
        };
        indiceUnidad = this.listadoUnidades.map(x => x.uidOperador).indexOf(this.historial.uidOperador);
      }
    } else {
      indiceUnidad = this.listadoUnidades.map(x => x.uidOperador).indexOf(this.historial.uidOperador);
    }
    if (indiceUnidad !== -1) {
      undadAlias = this.listadoUnidades[indiceUnidad].alias;
      uidUnidad = this.listadoUnidades[indiceUnidad].uidUnidad;
    }
    this.model = {
      unidad: uidUnidad,
      undadAlias: undadAlias,
      incidencia: '',
      costo: '',
      fecha: moment().format('YYYY-MM-DDTHH:mm')
    };
    $('#unidadError').html('');
    $('#costoError').html('');
    $('#incidenciaError').html('');
    $('#incidenciaError').html('');
  }
  /**
   * Cierra modal de incidencias
   * y regresa variables a vacias
   */
  cerrarModalIncidencia() {
    $('#nuevaincidencia').modal('hide');
    if (this.historial.btn === 1) {
      this.historial = {};
      this.listadoIncidencias = [];
    }
  }
  /**
   * Nueva incidencia
   * @param uidInc Identificador de unidad
   * @param fecha Cuando ocurrio la incidencia
   * @param costo Costo total de la incidencia
   * @param incidencia Descripcion de la incidencia
   */
  nuevaIncidencia() {
    let errorunidad = null, errorcosto = null, errorincidencia = null, errorfecha = null, nuevocosto = null;
    if ((this.model.unidad === undefined || this.model.unidad === '') && this.historial.btn === 0) {
      errorunidad = 'No hay unidad asignada';
    } else if ((this.model.unidad === undefined || this.model.unidad === '') && this.historial.btn === 1) {
      errorunidad = 'No hay operador asignado';
    }
    if (this.model.fecha === undefined || this.model.fecha === '') {
      errorfecha = 'Campo obligatorio';
    } else if (this.model.fecha.length !== 16) {
      errorfecha = 'Fecha incorrecta';
    }
    if (this.model.costo === undefined || this.model.costo === '') {
      errorcosto = 'Campo obligatorio';
    } else {
      let posCosto = this.model.costo.indexOf('.');
      let cuenta = 0;
      while (posCosto !== -1) {
        cuenta++;
        posCosto = this.model.costo.indexOf('.', posCosto + 1);
      }
      if (cuenta <= 1) {
        nuevocosto = this.model.costo;
      } else {
        errorcosto = 'Solo puede contener un punto.';
      }
    }
    if (this.model.incidencia === undefined || this.model.incidencia === '') {
      errorincidencia = 'Campo obligatorio';
    }
    if (errorunidad == null && errorcosto == null && errorincidencia == null && errorfecha == null) {
      const unidad = parseInt(this.model.unidad);
      const fecha = moment(this.model.fecha + ':00', 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
      const datos = '\nUnidad: ' + this.model.undadAlias + '\nFecha: ' + moment(this.model.fecha, 'YYYY-MM-DDTHH:mm').format('DD-MM-YYYY HH:mm') + '\nCosto: ' + nuevocosto + '\nIncidencia: ' + this.model.incidencia;
      swal({
        title: '¡Nueva Incidencia!',
        text: 'Se creara con los siguientes datos:' + datos + '\n¿Deseas crear la incidencia?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CREAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'CREAR') {
              swal('¡Error!', 'No se ha escrito \'CREAR\' correctamente', 'error');
            } else {
              this.operadoresService.nuevaIncidencia(unidad, nuevocosto, this.model.incidencia, fecha, this.listadoOperadores[this.historial.indice].id).toPromise().then(data => {
                if (data.length > 0) {
                  $('#nohayIncidencias').remove();
                  const fechaIncidencia = moment(data[0].fecha_incidencia, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm');
                  const placas = (data[0].placas == null) ? ' --- ' : data[0].placas;
                  const estatus = (data[0].estatus == null) ? 'Sin estatus' : data[0].estatus;
                  this.listadoIncidencias.push({
                    uidIns: data[0].uidIns,
                    uid: data[0].uid,
                    unidad: data[0].alias,
                    placas: placas,
                    incidencia: data[0].incidencia,
                    fecha: fechaIncidencia,
                    costo: data[0].costo,
                    estatus: estatus
                  });
                  // $('#tbl-incidencias > tbody').append('<tr id="inc'+data[0].uidIns+'" class="incidencia'+this.historial.uidOperador+'"><td>-</td><td>'+data[0].alias+'</td><td>'+placas+'</td><td>'+data[0].incidencia+'</td><td>'+fechaIncidencia+'</td><td>$ '+data[0].costo+'</td><td>$ '+estatus+'</td><td><button class="btn btn-primary btn-sm btonesO" (click)="modalEditarIncidencia('+data[0].uidIns+')" data-toggle="modal" data-target="#editarIncidencia">Editar Estatus</button></td></tr>');
                  this.cerrarModalIncidencia();
                  swal('Se creo nueva incidencia correctamente', {
                    icon: 'success',
                  });
                } else {
                  swal({
                    title: 'Hubo un error al crear nueva incidencia',
                    icon: 'error',
                    className: 'swalOperador',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });

    } else {
      $('#unidadError').html(errorunidad);
      $('#costoError').html(errorcosto);
      $('#incidenciaError').html(errorincidencia);
      $('#fechaIncidenciaError').html(errorfecha);
    }
  }
  /**
   * Prepara las variables para nueva incidencia
   * @param uidInc Identificador de unidad
   */
  modalEditarIncidencia(uidInc) {
    this.model = {};
    const indiceIncidencia = this.listadoIncidencias.map(x => x.uidIns).indexOf(uidInc);
    this.model = {
      unidad: this.listadoIncidencias[indiceIncidencia].unidad,
      fecha: this.listadoIncidencias[indiceIncidencia].fecha,
      costo: this.listadoIncidencias[indiceIncidencia].costo,
      incidencia: this.listadoIncidencias[indiceIncidencia].incidencia,
      estatusInc: (this.listadoIncidencias[indiceIncidencia].estatus === 'Sin estatus') ? '' : this.listadoIncidencias[indiceIncidencia].estatus,
      uidInc: uidInc
    };
    $('#estatusErrorI').html('');
  }
  /**
   * Para editar el estatus de la incidencia
   * Resuelta, Pagada y Pendiente
   * @param estatusInc Estatus de la incidencia
   * @param uidInc Identificador de incidencia
   */
  editarIncidencia() {
    let errorEstatus = null;
    if (this.model.estatusInc.length === 0 || this.model.estatusInc === '') {
      errorEstatus = 'Campo obligatorio';
    } else if (this.model.estatusInc !== 'Resuelta' && this.model.estatusInc !== 'Pagada' && this.model.estatusInc !== 'Pendiente') {
      errorEstatus = 'La opción no es valida';
    }
    if (errorEstatus == null) {
      swal({
        title: '¡Editar Incidencia',
        text: 'Se modificara el estatus por: "' + this.model.estatusInc + '"\n¿Deseas modificar el estatus de la incidencia?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'EDITAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'EDITAR') {
              swal('¡Error!', 'No se ha escrito \'EDITAR\' correctamente', 'error');
            } else {
              this.operadoresService.edtarIncidencia(this.model.uidInc, this.model.estatusInc).toPromise().then(data => {
                if (data['affectedRows'] === 1 && data['warningCount'] === 0) {
                  const indiceIncidencia = this.listadoIncidencias.map(x => x.uidIns).indexOf(this.model.uidInc);
                  this.listadoIncidencias[indiceIncidencia].estatus = this.model.estatusInc;
                  const tr = $('#incidencia' + this.model.uidInc);
                  // $("#incidencia"+this.model.uidInc).html(
                  //   '<td>'+tr[0].textContent.substring(0,1)+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].unidad+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].placas+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].incidencia+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].fecha+'</td>'+
                  //   '<td>$ '+this.listadoIncidencias[indiceIncidencia].costo+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].estatus+'</td>'+
                  //   '<td>'+
                  //     '<button class="btn btn-primary btn-sm btonesO" (click)="modalEditarIncidencia('+this.model.uidInc+')" data-toggle="modal" data-target="#editarIncidencia">Editar Estatus</button> '+
                  //   '</td>'
                  // );
                  $('#editarIncidencia').modal('hide');
                  swal('Se actualizo correctamente', {
                    icon: 'success',
                  });
                } else {
                  swal({
                    title: 'Hubo un error al modificar la incidencia',
                    icon: 'error',
                    className: 'swalOperador',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });
    } else {
      $('#estatusErrorI').html(errorEstatus);
    }
  }
  // Funciones Unidades
  /**
   * Abre listado de unidades
   */
  verUnidades() {
    document.getElementById('ventaUnidades').classList.add('abrir');
  }
  /**
   * Cierra listado de unidades
   */
  cerrarUnidades() {
    document.getElementById('ventaUnidades').classList.remove('abrir');
  }
  /**
   * Prepara las variables para la edicion de la unidad
   * @param unidadID Clave unica de unidad
   */
  modalEditarUnidad(unidadID) {
    this.model = {};
    let color, icono, uidOperador, uidGeo, fechaServicio, kilometraje, kmActual, consumo, placas, serie, modelo, anio, marca;
    this.colores = [
      { value: 'black', name: 'Negro', avatar: '../assets/images/negro.png' },
      { value: 'green', name: 'Verde', avatar: '../assets/images/verde.png' },
      { value: 'light_blue', name: 'Azul Claro', avatar: '../assets/images/azul_claro.png' },
      { value: 'light_grey', name: 'Gris', avatar: '../assets/images/gris.png' },
      { value: 'mid_blue', name: 'Azul', avatar: '../assets/images/azul.png' },
      { value: 'orange', name: 'Anaranjado', avatar: '../assets/images/anaranjado.png' },
      { value: 'pink', name: 'Rosa', avatar: '../assets/images/rosa.png' },
      { value: 'purple', name: 'Morado', avatar: '../assets/images/morado.png' },
      { value: 'red', name: 'Rojo', avatar: '../assets/images/rojo.png' },
      { value: 'yellow', name: 'Amarillo', avatar: '../assets/images/amarillo.png' }
    ];
    const indiceUnidad = this.listadoUnidades.map(x => x.uidUnidad).indexOf(unidadID);
    color = (this.listadoUnidades[indiceUnidad].color === '' || this.listadoUnidades[indiceUnidad].color == null) ? 'black' : this.listadoUnidades[indiceUnidad].color;
    icono = (this.listadoUnidades[indiceUnidad].icono === '' || this.listadoUnidades[indiceUnidad].icono == null || this.listadoUnidades[indiceUnidad].icono === 'default') ? 'automovil' : this.listadoUnidades[indiceUnidad].icono;
    uidOperador = (this.listadoUnidades[indiceUnidad].uidOperador === '' || this.listadoUnidades[indiceUnidad].uidOperador == null) ? '' : this.listadoUnidades[indiceUnidad].uidOperador;
    uidGeo = (this.listadoUnidades[indiceUnidad].uidGeo == null) ? '' : this.listadoUnidades[indiceUnidad].uidGeo;
    fechaServicio = (this.listadoUnidades[indiceUnidad].fechaServicio === ' --- ') ? '' : moment(this.listadoUnidades[indiceUnidad].fechaServicio, 'DD-MM-YYYY').format('YYYY-MM-DD');
    kilometraje = (this.listadoUnidades[indiceUnidad].km === ' --- ') ? '' : this.listadoUnidades[indiceUnidad].km;
    kmActual = (this.listadoUnidades[indiceUnidad].kmActual === 'Procesando...') ? 0.0 : parseFloat(this.listadoUnidades[indiceUnidad].kmActual).toFixed(2);
    consumo = (this.listadoUnidades[indiceUnidad].consumo === ' --- ') ? '' : this.listadoUnidades[indiceUnidad].consumo;
    placas = (this.listadoUnidades[indiceUnidad].placas == null) ? ' --- ' : this.listadoUnidades[indiceUnidad].placas;
    modelo = (this.listadoUnidades[indiceUnidad].modeloAct == null) ? ' --- ' : this.listadoUnidades[indiceUnidad].modeloAct;
    anio = (this.listadoUnidades[indiceUnidad].anioAct == null) ? ' --- ' : this.listadoUnidades[indiceUnidad].anioAct;
    marca = (this.listadoUnidades[indiceUnidad].marcaAct == null) ? ' --- ' : this.listadoUnidades[indiceUnidad].marcaAct;
    serie = this.listadoUnidades[indiceUnidad].serie;
    this.model = {
      uidunidad: unidadID,
      nombre: this.listadoUnidades[indiceUnidad].alias,
      operador: uidOperador,
      geocerca: uidGeo,
      color: color,
      icono: icono,
      fechaServicio: fechaServicio,
      minFecha: moment().format('YYYY-MM-DD'),
      periodo: this.listadoUnidades[indiceUnidad].periodo,
      kmServicio: kilometraje,
      kmActual: kmActual,
      consumo: consumo,
      placas: placas,
      serie: serie,
      modelo: modelo,
      anio: anio,
      marca: marca,
      index: indiceUnidad
    };

    if (this.jwtHelper.decodeToken(localStorage.getItem('access_token')).clienteID === 1 || this.jwtHelper.decodeToken(localStorage.getItem('access_token')).clienteID === 2) {
      this.iconos = [
        { class: 'iconoMicrocoche', value: 'microcoche', name: 'Microcoche', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoAutmovil', value: 'automovil', name: 'Automovil', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoDeportivo', value: 'deportivo', name: 'Deportivo', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoMinivan', value: 'minivan', name: 'Minivan', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoFurgoneta', value: 'furgoneta', name: 'Furgoneta', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoCamioneta', value: 'camioneta', name: 'Camioneta', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoEmpalmadora', value: 'empalmadora', name: 'Empalmadora', avatar: '../assets/images/empalmadora.png' },
        { class: 'iconoPesado', value: 'maquinaria_pesada', name: 'Maquinaria pesada', avatar: '../assets/images/' + color + '.png' }
      ];
    } else {
      this.iconos = [
        { class: 'iconoMicrocoche', value: 'microcoche', name: 'Microcoche', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoAutmovil', value: 'automovil', name: 'Automovil', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoDeportivo', value: 'deportivo', name: 'Deportivo', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoMinivan', value: 'minivan', name: 'Minivan', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoFurgoneta', value: 'furgoneta', name: 'Furgoneta', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoCamioneta', value: 'camioneta', name: 'Camioneta', avatar: '../assets/images/' + color + '.png' },
        { class: 'iconoEmpalmadora', value: 'empalmadora', name: 'Empalmadora', avatar: '../assets/images/empalmadora.png' },
      ];
    }
    $('#operadorError').html('');
    $('#geocercaError').html('');
    $('#iconoError').html('');
    $('#colorError').html('');
    $('#fechaError').html('');
    $('#kmServicioError').html('');
    $('#periodoError').html('');
    $('#consumoError').html('');
  }
  /**
   * trea los iconos del color seleccionado
   * @param event Color del icono
   * @param event Color del icono
   */
  selectIconoUnidad(event) {
    // tslint:disable-next-line:max-line-length
    if (this.jwtHelper.decodeToken(localStorage.getItem('access_token')).clienteID === 2 || this.jwtHelper.decodeToken(localStorage.getItem('access_token')).clienteID === 1) {
      this.iconos = [
        { class: 'iconoMicrocoche', value: 'microcoche', name: 'Microcoche', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoAutmovil', value: 'automovil', name: 'Automovil', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoDeportivo', value: 'deportivo', name: 'Deportivo', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoMinivan', value: 'minivan', name: 'Minivan', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoFurgoneta', value: 'furgoneta', name: 'Furgoneta', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoCamioneta', value: 'camioneta', name: 'Camioneta', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoEmpalmadora', value: 'empalmadora', name: 'Empalmadora', avatar: '../assets/images/empalmadora.png' },
        { class: 'iconoPesado', value: 'maquinaria_pesada', name: 'Maquinaria pesada', avatar: '../assets/images/' + event + '.png' }
      ];
    } else {
      this.iconos = [
        { class: 'iconoMicrocoche', value: 'microcoche', name: 'Microcoche', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoAutmovil', value: 'automovil', name: 'Automovil', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoDeportivo', value: 'deportivo', name: 'Deportivo', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoMinivan', value: 'minivan', name: 'Minivan', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoFurgoneta', value: 'furgoneta', name: 'Furgoneta', avatar: '../assets/images/' + event + '.png' },
        { class: 'iconoCamioneta', value: 'camioneta', name: 'Camioneta', avatar: '../assets/images/' + event + '.png' }
      ];
    }
    this.model.icono = 'automovil';
  }
  /**
   * trea los iconos del color seleccionado
   * @param operador Identificador de operador
   * @param geocerca Identificador de Geocerca
   * @param color Color del icono
   * @param icono Tipo de icono
   * @param fechaServicio Fecha de siguiente servicio
   * @param periodo Cuanto tiempo avisara antes de la fecha
   * @param kmServicio KM para realizar servicio
   * @param consumo Consumo estimado de gasolina
   **/
  editarUnidad() {
    // tslint:disable-next-line:max-line-length
    let erroroperador = null, errorgeocerca = null, errorcolor = null, erroricono = null, errorfecha = null, errorkm = null, errorperiodo = null, errorconsumo = null, errorotros = null;
    // tslint:disable-next-line:max-line-length
    let nuevooperador, nuevogeocerca, nuevofecha, nuevoperiodo, nuevokm, nuevoconsumo, nombreGeo = 'Sin asignación', nombreOperador = 'Sin asignación', placas = null, modelo = null, anio = null, marca = null, serie = null;
    if (this.model.operador === undefined || this.model.operador.length === 0 || this.model.operador === '') {
      nuevooperador = null;
    } else {
      let indiceUnidad = -1;
      indiceUnidad = this.listadoUnidades.map(x => x.uidOperador).indexOf(this.model.operador);
      if (indiceUnidad !== -1 && this.model.uidunidad !== this.listadoUnidades[indiceUnidad].uidUnidad) {
        erroroperador = 'Operador ya tienen unidad asignada';
      } else {
        const indiceOperador = this.listadoOperadores.map(x => x.uid).indexOf(this.model.operador);
        if (this.model.operador.length !== 11 && indiceOperador === -1) {
          erroroperador = 'Operador no coincide con existentes.';
        } else {
          nuevooperador = this.listadoOperadores[indiceOperador].id;
          nombreOperador = this.listadoOperadores[indiceOperador].nombre + ' ' + this.listadoOperadores[indiceOperador].paterno + ' ' + this.listadoOperadores[indiceOperador].materno;
        }
      }
    }
    if (this.model.geocerca === undefined || this.model.geocerca.length === 0 || this.model.geocerca === '') {
      nuevogeocerca = null;
    } else {
      const indiceGeo = this.geocercasList.map(x => x.idtbl_geocercas).indexOf(parseInt(this.model.geocerca));      
      if (indiceGeo === 0) {                
        errorgeocerca = 'Geocerca no coincide con existentes.';
      } else {        
        nuevogeocerca = this.model.geocerca;
        nombreGeo = '';
      }
    }
    if (this.model.color === undefined || this.model.color.length === 0 || this.model.color === '') {
      errorcolor = 'Campo obligatorio';
    } else {
      let done = false;
      this.colores.forEach(element => {
        if (done) { return; }
        if (element.value === this.model.color) {
          done = true;
          return;
        }
      });
      if (!done) {
        errorcolor = 'No coincide con un valor de la lista';
      }
    }
    if (this.model.icono === undefined || this.model.icono.length === 0 || this.model.icono === '') {
      erroricono = 'Campo obligatorio';
    } else {
      let done = false;
      this.iconos.forEach(element => {
        if (done) { return; }
        if (element.value === this.model.icono) {
          done = true;
          return;
        }
      });
      if (!done) {
        erroricono = 'No coincide con un valor de la lista';
      }
    }
    if (this.model.fechaServicio === undefined || this.model.fechaServicio.length === 0 || this.model.fechaServicio === '') {
      nuevofecha = null;
    } else {
      if (this.model.fechaServicio.length === 10) {
        nuevofecha = this.model.fechaServicio;
      } else {
        errorfecha = 'No tiene el formato adecuado';
      }
      if (this.model.periodo === undefined || this.model.periodo.length === 0 || this.model.periodo === '') {
        errorperiodo = 'Campo obligatorio';
      } else {
        nuevoperiodo = this.model.periodo;
      }
    }
    if (this.model.kmServicio === undefined || this.model.kmServicio.length === 0 || this.model.kmServicio === '') {
      nuevokm = null;
    } else {
      let posKm = String(this.model.kmServicio).indexOf('.');
      let cuenta = 0;
      while (posKm !== -1) {
        cuenta++;
        posKm = String(this.model.kmServicio).indexOf('.', posKm + 1);
      }
      if (cuenta <= 1) {
        nuevokm = parseFloat(this.model.kmServicio);
      } else {
        errorkm = 'Solo puede contener un punto.';
      }
    }
    if (this.model.consumo === undefined || this.model.consumo.length === 0 || this.model.consumo === '') {
      nuevoconsumo = null;
    } else {
      let posConsumo = this.model.consumo.indexOf('.');
      let cuenta = 0;
      while (posConsumo !== -1) {
        cuenta++;
        posConsumo = this.model.consumo.indexOf('.', posConsumo + 1);
      }
      if (cuenta <= 1) {
        nuevoconsumo = this.model.consumo;
      } else {
        errorconsumo = 'Solo puede contener un punto.';
      }
    }
    if (isNaN(parseInt(this.model.uidunidad))) {
      errorotros = 'Campo debe contener solo números';
    }
    placas = this.model.placas;
    anio = this.model.anio;
    marca = this.model.marca;
    modelo = this.model.modelo;
    serie = this.model.serie;
    if (erroroperador == null && errorgeocerca == null && errorcolor == null && erroricono == null && errorfecha == null && errorkm == null && errorperiodo == null && errorconsumo == null && errorotros == null) {
      const color = (this.model.icono === 'empalmadora') ? '' : this.model.color;
      const datos = '\nOperador: ' + nombreOperador +
        '\nGeocerca: ' + nombreGeo +
        '\nColor: ' + color +
        '\nIcono: ' + this.model.icono +
        '\nFecha de servicio: ' + nuevofecha +
        '\nNotificar en: ' + nuevoperiodo +
        '\nPlacas: ' + placas +
        '\nModelo: ' + modelo +
        '\nMarca: ' + marca +
        '\nAño: ' + anio +
        '\nSerie: ' + serie +
        '\nKilometraje servicio: ' + nuevokm +
        '\nKm recorridos por Litro: ' + nuevoconsumo;
      swal({
        title: '¡Editar Unidad!',
        text: 'Se editara con los siguientes datos:' + datos + '\n¿Deseas editar la unidad?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'EDITAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'EDITAR') {
              swal('¡Error!', 'No se ha escrito \'EDITAR\' correctamente', 'error');
            } else {
              this.operadoresService.actualizarUnidad(this.model.uidunidad, nuevooperador, nuevogeocerca, nuevoconsumo, this.model.icono, color, nuevofecha, nuevokm, nuevoperiodo, serie, modelo, marca, anio, placas).toPromise().then(data => {
                if (data == null || data === '' || data.length === 0 || data === []) {
                  swal({
                    title: 'Hubo un error al editar la unidad',
                    icon: 'error',
                  });
                } else {
                  // Cambio operador
                  if (nuevooperador == null) {
                    this.listadoUnidades[this.model.index].uidOperador = null;
                    this.listadoUnidades[this.model.index].operador = 'Sin asignación';
                    this.listadoUnidades[this.model.index].licencia = 'Sin asignación';
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].operador = 'Sin asignación';
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].tbl_operadores_idtbl_operadores = null;
                  } else {
                    const indiceOperador = this.listadoOperadores.map(x => x.uid).indexOf(this.model.operador);
                    this.listadoUnidades[this.model.index].uidOperador = this.model.operador;
                    this.listadoUnidades[this.model.index].nombre = this.listadoOperadores[indiceOperador].nombre + ' ' + this.listadoOperadores[indiceOperador].paterno + ' ' + this.listadoOperadores[indiceOperador].materno;
                    this.listadoUnidades[this.model.index].licencia = this.listadoOperadores[indiceOperador].licencia;
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].operador = this.listadoOperadores[indiceOperador].nombre + ' ' + this.listadoOperadores[indiceOperador].paterno + ' ' + this.listadoOperadores[indiceOperador].materno;
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].tbl_operadores_idtbl_operadores = this.listadoOperadores[indiceOperador].id;
                  }
                  // Cambio Geocerca
                  if (nuevogeocerca == null) {
                    this.listadoUnidades[this.model.index].uidGeo = null;
                    this.listadoUnidades[this.model.index].nombreGeo = 'Sin Asignación';
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].tbl_geocercas_idtbl_geocercas = null;
                  } else {
                    const indiceGeo = this.geocercasList.map(x => x.idtbl_geocercas).indexOf(parseInt(this.model.geocerca));                    
                    //this.listadoUnidades[this.model.index].uidGeo = this.geocercasList[indiceGeo].idtbl_geocercas;
                    //this.listadoUnidades[this.model.index].nombreGeo = this.geocercasList[indiceGeo].nombre;
                    //this.dispositivo[this.listadoUnidades[this.model.index].imei].tbl_geocercas_idtbl_geocercas = this.geocercasList[indiceGeo].idtbl_geocercas;
                  }
                  // Cambio Color e Icono
                  if (data.checkUnidad.icono !== this.model.icono || data.checkUnidad.color !== color) {
                    const claseanterior = data.checkUnidad.icono + '' + data.checkUnidad.color;
                    const calsenueva = this.model.icono + '' + color;
                    $('.' + this.listadoUnidades[this.model.index].imei).removeClass(claseanterior);
                    $('.' + this.listadoUnidades[this.model.index].imei).addClass(calsenueva);
                    this.listadoUnidades[this.model.index].color = color;
                    this.listadoUnidades[this.model.index].icono = this.model.icono;
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].color = color;
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].icono = this.model.icono;
                  }
                  // Notificar en
                  if (nuevoperiodo == null) {
                    this.listadoUnidades[this.model.index].periodo = '';
                    this.listadoUnidades[this.model.index].txtperiodo = ' --- ';
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].periodo = null;
                  } else {
                    let periodo = null;
                    switch (nuevoperiodo) {
                      case '1-month':
                        periodo = '1 Mes';
                        break;
                      case '2-month':
                        periodo = '2 Meses';
                        break;
                      case '3-month':
                        periodo = '3 Meses';
                        break;
                      case '4-month':
                        periodo = '4 Meses';
                        break;
                      default:
                        periodo = null;
                        break;
                    }
                    this.listadoUnidades[this.model.index].periodo = nuevoperiodo;
                    this.listadoUnidades[this.model.index].txtperiodo = (periodo == null) ? ' --- ' : periodo;
                    this.dispositivo[this.listadoUnidades[this.model.index].imei].periodo = nuevoperiodo;
                  }
                  if(serie != null){                    
                    this.listadoUnidades[this.model.index].placas = placas;
                  } 
                  if(modelo != null){                    
                    this.listadoUnidades[this.model.index].modeloAct = modelo;
                  } 
                  if(marca != null){
                    this.listadoUnidades[this.model.index].marcaAct = marca;
                  } 
                  if(anio != null){
                    this.listadoUnidades[this.model.index].anioAct = anio;
                  } 
                  if(marca != null && modelo != null && anio != null){
                    this.listadoUnidades[this.model.index].modelo = marca + ' ' + modelo + ' ' + anio;
                  }
                  if(placas != null){
                    this.listadoUnidades[this.model.index].placas = placas;
                  }
                  // Cambio Fecha
                  if (nuevofecha != null) {
                    let clase = null, faltan = '';
                    const dateNow = moment();
                    const periodo = nuevoperiodo.split('-');
                    const fechaAvisar = moment(nuevofecha).subtract(periodo[0], periodo[1]).format('YYYY-MM-DD');
                    if (dateNow.isBefore(fechaAvisar)) {
                      clase = '';
                    } else if (dateNow.isBetween(fechaAvisar, nuevofecha)) {
                      clase = 'table-warning';
                    } else if (dateNow.isSameOrAfter(fechaAvisar)) {
                      clase = 'table-danger';
                    }
                    if (moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
                      faltan = 'Falta ' + moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
                    } else if (moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
                      faltan = 'Falta ' + moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
                    } else if (moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
                      faltan = 'Falta ' + moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
                    } else if (moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
                      faltan = 'Falta ' + moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
                    } else if (moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
                      faltan = 'Necesita servicio.';
                    } else {
                      faltan = 'Necesita servicio. Se ha pasado por ' + (moment(nuevofecha, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
                    }
                    this.listadoUnidades[this.model.index].fechaServicio = moment(nuevofecha).format('DD-MM-YYYY');
                    this.listadoUnidades[this.model.index].clase = clase;
                    this.listadoUnidades[this.model.index].faltan = 'Por fecha: ' + faltan;
                  } else {
                    this.listadoUnidades[this.model.index].fechaServicio = ' --- ';
                    this.listadoUnidades[this.model.index].clase = '';
                    this.listadoUnidades[this.model.index].faltan = '';
                  }
                  // Cambio KM
                  if (nuevokm != null) {
                    let falta = null;
                    const kmActual = parseFloat(this.listadoUnidades[this.model.index].kmActual);
                    const kmnuevo = parseFloat(nuevokm);
                    const resta = (nuevokm - 1700);

                    if (kmActual >= resta && kmActual < kmnuevo) {

                      this.listadoUnidades[this.model.index].claseKm = 'table-warning';
                      falta = 'Faltan ' + (kmnuevo - kmActual).toFixed(2) + ' Km.';

                    } else if (kmActual === kmnuevo) {

                      this.listadoUnidades[this.model.index].claseKm = 'table-danger';
                      falta = 'Necesita servicio por kilometraje.';

                    } else if (kmActual > kmnuevo) {

                      this.listadoUnidades[this.model.index].claseKm = 'table-danger';
                      falta = 'Necesita servicio por kilometraje. Se ha pasado por  ' + (kmActual - kmnuevo).toFixed(2) + ' Km.';

                    } else {

                      falta = 'Faltan ' + (kmnuevo - kmActual).toFixed(2) + ' Km.';

                    }
                    this.listadoUnidades[this.model.index].km = nuevokm;
                    this.listadoUnidades[this.model.index].faltanKM = (falta == null) ? '' : 'Por kilometraje: ' + falta;
                  } else {
                    this.listadoUnidades[this.model.index].km = ' --- ';
                    this.listadoUnidades[this.model.index].faltanKM = '';
                    this.listadoUnidades[this.model.index].claseKm = '';
                  }
                  // Consuo Km x 1L
                  this.listadoUnidades[this.model.index].consumo = (this.listadoUnidades[this.model.index].faltan === '') ? ' --- ' : nuevoconsumo;
                  $('#nodalUnidad').modal('hide');
                  swal('Se actualizo correctamente', {
                    icon: 'success',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });

    } else {
      $('#operadorError').html(erroroperador);
      $('#geocercaError').html(errorgeocerca);
      $('#iconoError').html(errorcolor);
      $('#colorError').html(erroricono);
      $('#fechaError').html(errorfecha);
      $('#kmServicioError').html(errorkm);
      $('#periodoError').html(errorperiodo);
      $('#consumoError').html(errorconsumo);
    }
  }
  /**
   * Abre historial de la unidad todas sus asignaciones,
   * los servicios que se han realizado
   * @param unidadID Clave unica de unidad
   * @param listadoAsignaciones Todas las asignaciones
   * @param listadoServicios Todos los servicios
   */
  historialUnidades(unidadID) {
    this.historial = {};
    let arrayTemp: Array<any> = [];
    this.listadoAsignaciones = [];
    this.listadoServicios = [];
    this.operadoresService.historilUnidad(unidadID).toPromise().then(data => {
      $('#asignaciones-tab').tab('show');
      if (Object.entries(data.asinaciones).length > 0) {
        data.asinaciones.forEach(element => {
          arrayTemp.push({
            nombre: element.nombre + ' ' + element.paterno + ' ' + element.materno,
            empleado: (element.empleado == null) ? ' --- ' : element.empleado,
            licencia: (element.licencia == null) ? ' --- ' : element.licencia,
            asignacion: moment(element.asignacion, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm'),
            termina: (element.estatus === 1) ? ' Asignada actualmente ' : moment(element.termina, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm')
          });
        });
        this.listadoAsignaciones = arrayTemp;
      }
      arrayTemp = [];
      if (Object.entries(data.servicios).length > 0) {
        data.servicios.forEach(element => {
          arrayTemp.push({
            uidServ: element.uid,
            servicio: moment(element.servicio, 'YYYY-MM-DD').format('DD-MM-YYYY'),
            creacion: moment(element.creacion, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm'),
            detalle: element.detalle
          });
        });
        this.listadoServicios = arrayTemp;
      }
      const indiceUnidad = this.listadoUnidades.map(x => x.uidUnidad).indexOf(unidadID);
      this.historial = {
        btn: 0,
        uidUnidad: unidadID,
        alias: this.listadoUnidades[indiceUnidad].alias,
        indice: indiceUnidad
      };
    });
  }
  /**
   * Cierra la venta de historial de unidad
   * las variables vuelven a estar vacias
   */
  cerrarVentanaHistorialUnidad() {
    $('.servicio' + this.historial.uidUnidad).remove();
    this.historial = {};
    this.listadoAsignaciones = [];
    this.listadoServicios = [];
  }
  /**
   * Prepara variables para un nuevo servicio para la unidad
   * @param unidadID Clave unica de unidad
   * @param fecha Fecha cuando se realizo el servicio
   * @param detalle Descripcion del servicio
   */
  modalNuevoServicio(unidadID = null) {
    this.model = {};
    if ((Object.entries(this.historial).length === 0)) {
      this.historial = {};
      const indiceUnidad = this.listadoUnidades.map(x => x.uidUnidad).indexOf(unidadID);
      this.historial = {
        btn: 1,
        uidUnidad: unidadID,
        alias: this.listadoUnidades[indiceUnidad].alias,
        indice: indiceUnidad
      };
    }
    this.model = {
      fecha: moment().format('YYYY-MM-DD'),
      detalle: ''
    };
    $('#fechaServicioError').html('');
    $('#detalleServicioError').html('');
  }
  /**
   * Cierra modal de nuevo servicio
   * vaciando las variables
   */
  cerrarModalServicio() {
    $('#nuevoservicio').modal('hide');
    if (this.historial.btn === 1) {
      this.historial = {};
      this.listadoServicios = [];
    }
  }
  /**
   * Crea un nuevo servicio para la unidad validando los campos
   * @param unidadID Clave unica de unidad
   * @param fecha Fecha cuando se realizo el servicio
   * @param detalle Descripcion del servicio
   */
  nuevoServicio() {
    let errorfecha = null, errordetalle = null, newfecha;
    if (this.model.fecha === undefined || this.model.fecha === '') {
      errorfecha = 'Campo obligatorio';
    } else if (this.model.fecha.length !== 10) {
      errorfecha = 'Fecha incorrecta';
    }
    if (this.model.detalle === undefined || this.model.detalle === '') {
      errordetalle = 'Campo obligatorio';
    }
    if (errorfecha == null && errordetalle == null) {
      const uidUnidad = parseInt(this.historial.uidUnidad);
      const datos = '\nFecha: ' + moment(this.model.fecha, 'YYYY-MM-DD').format('DD-MM-YYYY') + '\nDetalle: ' + this.model.detalle;
      swal({
        title: '¡Nuevo Servicio!',
        text: 'Se creara con los siguientes datos:' + datos + '\n¿Deseas crear el servicio?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CREAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'CREAR') {
              swal('¡Error!', 'No se ha escrito \'CREAR\' correctamente', 'error');
            } else {
              this.operadoresService.nuevoServicio(uidUnidad, this.model.fecha, this.model.detalle).toPromise().then(data => {
                if (data.length > 0) {
                  $('#nohayServicios').remove();
                  this.listadoServicios.push({
                    uidServ: data[0].uid,
                    servicio: moment(data[0].servicio, 'YYYY-MM-DD').format('DD-MM-YYYY'),
                    creacion: moment(data[0].creacion, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm'),
                    detalle: data[0].detalle
                  });
                  // $('#tbl-incidencias > tbody').append('<tr id="inc'+data[0].uidIns+'" class="incidencia'+this.historial.uidOperador+'"><td>-</td><td>'+data[0].alias+'</td><td>'+placas+'</td><td>'+data[0].incidencia+'</td><td>'+fechaIncidencia+'</td><td>$ '+data[0].costo+'</td><td>$ '+estatus+'</td><td><button class="btn btn-primary btn-sm btonesO" (click)="modalEditarIncidencia('+data[0].uidIns+')" data-toggle="modal" data-target="#editarIncidencia">Editar Estatus</button></td></tr>');
                  this.cerrarModalServicio();
                  swal('Se creo nuevo servicio correctamente', {
                    icon: 'success',
                  });
                } else {
                  swal({
                    title: 'Hubo un error al crear nuevo servicio',
                    icon: 'error',
                    className: 'swalOperador',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });

    } else {
      $('#fechaServicioError').html(errorfecha);
      $('#detalleServicioError').html(errordetalle);
    }
  }
  // Funciones de Restablecer contraseña
  /**
   * Abre modal de cambio de contraseña
   * cuando no se ha cambiado la contraseña por default
   * @param contrasena Nueva contraseña
   * @param confirmar Confirmacion de nueva contrasena
   */
  abrirModalResetPass() {
    this.model = {};
    this.model = {
      contrasena: '',
      confirmar: ''
    };
    $('#contrasenaHelp').html('');
    $('#confirmarHelp').html('');
    $('#resetPass').modal('show');

  }
  /**
   * Se valida la nueva contraseña, que sean iguales,
   * 8 caracteres como minimo
   * @param contrasena Nueva contraseña
   * @param confirmar Confirmacion de nueva contrasena
   */
  forzarNuevaPass() {
    let errorcontrasena = null, errorconfirmar = null;
    if (this.model.contrasena.length === 0 || this.model.contrasena === '') {
      errorcontrasena = 'Campo obligatorio';
    } else if (this.model.contrasena.length < 8) {
      errorcontrasena === 'La contraseña debe ser minimo 8 caracteres.';
    }
    if (this.model.confirmar.length === 0 || this.model.confirmar === '') {
      errorconfirmar = 'Campo obligatorio';
    } else if (this.model.confirmar.length < 8) {
      errorconfirmar = 'La contraseña debe ser minimo 8 caracteres.';
    } else if (this.model.confirmar !== this.model.contrasena) {
      errorconfirmar = 'No coinciden las contraseñas';
    }
    if (errorcontrasena == null && errorconfirmar == null) {
      swal({
        title: '¡Nueva Contraseña!',
        text: 'Se actualizara su contraseña por el dato agregado \n¿Estas seguro de su contraseña?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'ACTUALIZAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'ACTUALIZAR') {
              swal('¡Error!', 'No se ha escrito \'ACTUALIZAR\' correctamente', 'error');
            } else {
              this.usuarios.restablecerPass(this.model.contrasena).toPromise().then(data => {
                if (data['affectedRows'] === 1 && data['warningCount'] === 0) {
                  $('#resetPass').modal('hide');
                  swal('Se actualizo correctamente', {
                    icon: 'success',
                    // @ts-ignore
                    buttons: {
                      cancel: false,
                      confirm: false,
                    },
                    timer: 2000,
                  });
                  this.auth.logout();
                  this.router.navigate(['login']);
                } else {
                  swal({
                    title: 'Hubo un error al actualizar la contraseña.',
                    icon: 'error',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });
    } else {
      $('#contrasenaHelp').html(errorcontrasena);
      $('#confirmarHelp').html(errorconfirmar);
    }
  }

  // Usuarios
  /**
   * Revisa si hay usuarios tienes permisos para poder
   * asignar o desasignar unidades que puede ver en la plataforma,
   * abre la venta de usuarios
   */
  verUsuarios() {
    if (this.listadoUsuarios.length !== 0) {
      document.getElementById('ventanaUsuarios').classList.add('abrir');
    } else {
      swal('¡Acceso denegado!', 'No tienes los permisos necesarios para acceder.', 'warning');
    }
  }
  /**
   * Cierra la venta de usuarios
   */
  cerrarUsuarios() {
    document.getElementById('ventanaUsuarios').classList.remove('abrir');
  }
  /**
   * Prepara los datos para la asignacion o desasignacion
   * de las unidades que puede ver en la plataforma
   * @param unidadesAsignadas Las que tiene actualmente asignadas
   * @param dropdownList Unidades que s epueden asignar para verlas en la plataforma
   * @param userUID Clave unica del usuario
   */
  modalAsignarUnidad(userUID) {
    this.model = {};
    const indiceUsuario = this.listadoUsuarios.map(x => x.usuarioID).indexOf(userUID);
    const selectedItems = [];
    const unidadesT: Array<any> = [];
    const unidadesAsignadas = [];
    if (this.listadoUsuarios[indiceUsuario].unidadesID != null) {
      this.listadoUsuarios[indiceUsuario].unidadesID.forEach(element => {
        const indiceunidad = this.listadoUnidades.map(x => x.uidUnidad).indexOf(parseInt(element));
        if (indiceunidad !== -1) {
          selectedItems.push({
            item_id: this.listadoUnidades[indiceunidad].uidUnidad,
            item_text: this.listadoUnidades[indiceunidad].alias
          });
          unidadesAsignadas.push(this.listadoUnidades[indiceunidad].alias);
        }
      });
    }
    this.listadoUnidades.forEach(element => {
      unidadesT.push({
        item_id: element.uidUnidad,
        item_text: element.alias
      });
    });
    this.model = {
      nombreU: this.listadoUsuarios[indiceUsuario].nombres + ' ' + this.listadoUsuarios[indiceUsuario].apellidos,
      selectedItems: selectedItems,
      dropdownList: unidadesT,
      dropdownSettings: {
        singleSelection: false,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'Selecionar todos',
        unSelectAllText: 'Deseleccionar todos',
        searchPlaceholderText: 'Buscar..',
        allowSearchFilter: true
      },
      unidadesAsignadas: unidadesAsignadas,
      indiceUsuario: indiceUsuario
    };
    $('#unidadesError').html('');
  }
  /**
   * Prepara los datos para la asignacion o desasignacion
   * de las unidades que puede ver en la plataforma
   * @param unidaes Las unidades a asignar
   * @param userUID Clave unica del usuario
   */
  asignarUnidades() {
    let errorSelecd = null, unidaes = [], alias = [], cont = 0;
    this.model.selectedItems.forEach(element => {
      const indiceunidad = this.listadoUnidades.map(x => x.uidUnidad).indexOf(parseInt(element.item_id));
      if (indiceunidad !== -1) {
        unidaes.push(this.listadoUnidades[indiceunidad].uidUnidad);
        alias.push(element.item_text);
      } else {
        cont++;
      }
    });
    if (cont > 0) {
      errorSelecd = 'Alguna unidad no es correcta favor de recargar la pagina.';
      unidaes = [];
      alias = [];
    }
    if (errorSelecd == null) {
      const txt = (alias.length > 0) ? alias.toString() : 'No selecciono unidades para asignadas';
      swal({
        title: '¡Nueva Asignación!',
        text: 'Las unidades asignadas son ' + txt + '.\nPara el usuario ' + this.model.nombreU + '\n¿Estas seguro de la signación?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'ASIGNAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'ASIGNAR') {
              swal('¡Error!', 'No se ha escrito \'ASIGNAR\' correctamente', 'error');
            } else {
              this.usuarios.asignarunidades(unidaes, this.listadoUsuarios[this.model.indiceUsuario].usuarioID).toPromise().then(data => {
                if (data['warningCount'] === 0) {
                  this.listadoUsuarios[this.model.indiceUsuario].unidadesID = (unidaes.length === 0) ? null : unidaes;
                  // tslint:disable-next-line:max-line-length
                  this.listadoUsuarios[this.model.indiceUsuario].unidadesAlias = (alias.length === 0) ? 'No hay unidades asignadas' : alias.toString();
                  $('#modalUsuarioUnidades').modal('hide');
                  swal('Se actualizo correctamente', {
                    icon: 'success',
                  });
                } else {
                  swal({
                    title: 'Hubo un error al actualizar la contraseña.',
                    icon: 'error',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });
    } else {
      $('#unidadesError').html(errorSelecd);
    }
  }

  can100(imei, data) {

    if (data.Comando !== '+RESP:GTCAN') {
      return 0;
    }

    if (data.IgnitionKey !== undefined) {
      this.dispositivo[imei].ignicionClass = 'text-success';
      switch (data.IgnitionKey) {
        case ('0'): {
          this.dispositivo[imei].ignicion = 'Off';
          break;
        }
        case ('1'): {
          this.dispositivo[imei].ignicion = 'On';
          break;
        }
        case ('2'): {
          this.dispositivo[imei].ignicion = 'Encendido';
          break;
        }
      }
    }
    if (data.TotalDistance !== undefined) {
      this.dispositivo[imei].kilometrajaCanClass = 'text-success';
      this.dispositivo[imei].kilometrajaCan = data.TotalDistance;
    }

    if (data.EngineRPM !== undefined) {
      this.dispositivo[imei].rpmClass = 'text-success';
      this.dispositivo[imei].rpm = data.EngineRPM;
    }

    if (data.Speed !== undefined) {
      this.dispositivo[imei].velocidadCanClass = 'text-success';
      this.dispositivo[imei].velocidadCan = data.VehicleSpeed;
    }
    if (data.EngineCoolantTemperature !== undefined) {
      this.dispositivo[imei].temperaturaClass = 'text-success';
      this.dispositivo[imei].temperatura = data.EngineCoolantTemperature;
    }
    if (data.FuelLevel !== undefined) {
      this.dispositivo[imei].gasolinaClass = 'text-success';
      this.dispositivo[imei].gasolina = data.FuelLevel;
    }

    if (data.Doors !== undefined) {
      this.dispositivo[imei].doorsClass = 'text-success';
      switch (data.Doors) {
        case ('00'): {
          this.dispositivo[imei].doors = 'Cerradas';
          break;
        }
        case ('03'): {
          this.dispositivo[imei].doors = 'Abiertas';
          break;
        }
      }
    }

  }


  seteo_valores(imei, reporte) {


    // Estado Actual
    if (reporte.State !== undefined) {
      this.dispositivo[reporte.IMEI].estadoActualClass = 'text-success';
      switch (reporte.State) {
        case ('16'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Remolcado.';
          break;
        }
        case ('1A'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Posiblemente Remolcado';
          break;
        }
        case ('11'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Estacionado';
          break;
        }
        case ('12'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Apagando en movimiento';
          break;
        }
        case ('21'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Encendido sin movimiento';
          break;
        }
        case ('22'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Encendido y en movimiento';
          break;
        }
        case ('41'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Estacionado sin señal de ignición';
          break;
        }
        case ('42'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'En movimiento sin señal de ignición';
          break;
        }
      }
    }

    if (reporte.DeviceStatus !== undefined) {
      this.dispositivo[reporte.IMEI].estadoActualClass = 'text-success';
      switch (reporte.DeviceStatus.substring(0, 1)) {
        case ('16'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Remolcado.';
          break;
        }
        case ('1A'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Posiblemente Remolcado';
          break;
        }
        case ('11'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Estacionado';
          break;
        }
        case ('12'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Apagando en movimiento';
          break;
        }
        case ('21'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Encendido sin movimiento';
          break;
        }
        case ('22'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Encendido y en movimiento';
          break;
        }
        case ('41'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'Estacionado sin señal de ignición';
          break;
        }
        case ('42'): {
          this.dispositivo[reporte.IMEI].estadoActual = 'En movimiento sin señal de ignición';
          break;
        }
      }
    }

    // streetView
    if ((typeof this.dispositivo[reporte.IMEI].streetview) === 'object') {
      try {
        this.dispositivo[reporte.IMEI].streetview.setPosition({ lat: parseFloat(reporte.Latitude), lng: parseFloat(reporte.Longitude) });
        this.obtenerDireccion(reporte.Latitude, reporte.Longitude, reporte.IMEI);
      } catch (error) {
        console.error('Coordenadas no validas 1.0');
      }

    }
    //

    // Estado paro de motor
    if (reporte.DeviceStatus !== undefined && reporte.DeviceStatus.substring(5, 6) === '2') {
      this.dispositivo[reporte.IMEI].paroDeMotor = true;
      this.dispositivo[reporte.IMEI].paroDeMotorClass = 'text-success';
    }

    if (reporte.DigitalOutput !== undefined && (reporte.DigitalOutput === '02' || reporte.DigitalOutput === '01')) {
      this.dispositivo[reporte.IMEI].paroDeMotor = true;
      this.dispositivo[reporte.IMEI].paroDeMotorClass = 'text-success';
    }

    if ((reporte.DeviceStatus) !== undefined && reporte.DeviceStatus.substring(5, 6) === '0') {
      this.dispositivo[reporte.IMEI].paroDeMotor = false;
      this.dispositivo[reporte.IMEI].paroDeMotorClass = 'text-success';
    }

    if ((reporte.DigitalOutput) !== undefined && reporte.DigitalOutput === '00') {
      this.dispositivo[reporte.IMEI].paroDeMotor = false;
      this.dispositivo[reporte.IMEI].paroDeMotorClass = 'text-success';
    }
    //

    // Estado chapa
    if (reporte.DeviceStatus !== undefined && reporte.DeviceStatus.substring(5, 6) === '2') {
      this.dispositivo[reporte.IMEI].salidaTres = true;
      this.dispositivo[reporte.IMEI].salidaTresClass = 'text-success';
    }

    if (reporte.DigitalOutput !== undefined && (reporte.DigitalOutput === '02' || reporte.DigitalOutput === '01')) {
      this.dispositivo[reporte.IMEI].salidaTres = true;
      this.dispositivo[reporte.IMEI].salidaTresClass = 'text-success';
    }

    if ((reporte.DeviceStatus) !== undefined && reporte.DeviceStatus.substring(5, 6) === '0') {
      this.dispositivo[reporte.IMEI].salidaTres = false;
      this.dispositivo[reporte.IMEI].salidaTresClass = 'text-success';
    }

    if ((reporte.DigitalOutput) !== undefined && reporte.DigitalOutput === '00') {
      this.dispositivo[reporte.IMEI].salidaTres = false;
      this.dispositivo[reporte.IMEI].salidaTresClass = 'text-success';
    }
    //

    // Estado señal GSM
    if (reporte.CSQRSSI !== undefined) {
      reporte.CSQRSSI = parseInt(reporte.CSQRSSI);
      if (reporte.CSQRSSI === 0) {
        this.dispositivo[reporte.IMEI].gsm = 'Sin cobertura';
        this.dispositivo[reporte.IMEI].gsmClass = 'text-danger';
      } else if (reporte.CSQRSSI < 10) {
        this.dispositivo[reporte.IMEI].gsm = 'Baja cobertura';
        this.dispositivo[reporte.IMEI].gsmClass = 'text-warning';
      } else if (reporte.CSQRSSI >= 10 && reporte.CSQRSSI <= 14) {
        this.dispositivo[reporte.IMEI].gsm = 'Regular';
        this.dispositivo[reporte.IMEI].gsmClass = 'text-success';
      } else if (reporte.CSQRSSI >= 15 && reporte.CSQRSSI <= 19) {
        this.dispositivo[reporte.IMEI].gsm = 'Buena';
        this.dispositivo[reporte.IMEI].gsmClass = 'text-success';
      } else if (reporte.CSQRSSI >= 20 && reporte.CSQRSSI < 99) {
        this.dispositivo[reporte.IMEI].gsm = 'Muy buena';
        this.dispositivo[reporte.IMEI].gsmClass = 'text-success';
      } else if (reporte.CSQRSSI === 99) {
        this.dispositivo[reporte.IMEI].gsm = 'Unknown';
        this.dispositivo[reporte.IMEI].gsmClass = 'text-secondary';
      }

    }

    // Voltaje
    if (reporte.ExternalPowerVoltage !== undefined) {
      this.dispositivo[reporte.IMEI].voltajeExternoClass = 'text-success';
      this.dispositivo[reporte.IMEI].voltajeExterno = (parseInt(reporte.ExternalPowerVoltage) / 1000) + 'V.';
    }
    //

    // Kilometraje
    if (reporte.Mileage !== undefined) {
      this.dispositivo[reporte.IMEI].kilometrajeClass = 'text-success';
      this.dispositivo[reporte.IMEI].kilometraje = reporte.Mileage + 'Km.';
      // Agregado
      const indexUnidad = this.listadoUnidades.map(x => x.imei).indexOf(reporte.IMEI);
      if (indexUnidad !== -1) {
        if (this.listadoUnidades[indexUnidad].km !== ' --- ') {
          let falta = null;
          const km = parseFloat(this.listadoUnidades[indexUnidad].km);
          if (reporte.Mileage >= (km - 1700) && reporte.Mileage < km) {
            this.listadoUnidades[indexUnidad].claseKm = 'table-warning';
            falta = 'Faltan ' + (km - reporte.Mileage).toFixed(2) + ' Km.';
          } else if (reporte.Mileage === km) {
            this.listadoUnidades[indexUnidad].claseKm = 'table-danger';
            falta = 'Necesita servicio por kilometraje.';
          } else if (reporte.Mileage > km) {
            this.listadoUnidades[indexUnidad].claseKm = 'table-danger';
            falta = 'Necesita servicio por kilometraje. Se ha pasado por  ' + (reporte.Mileage - km).toFixed(2) + ' Km.';
          } else {
            falta = 'Faltan ' + (km - reporte.Mileage).toFixed(2) + ' Km.';
          }
          this.listadoUnidades[indexUnidad].faltanKM = (falta == null) ? '' : '\n Por kilometraje: ' + falta;
        }
        this.listadoUnidades[indexUnidad].kmActual = reporte.Mileage;
      }
    }
    //

    // Alimentación Externa
    if (reporte.ExternalpowerSupply !== undefined) {
      if (reporte.ExternalpowerSupply === '0') {
        this.dispositivo[reporte.IMEI].alimentacionExternaClass = 'text-danger';
        this.dispositivo[reporte.IMEI].alimentacionExterna = 'Desconectado';
      } else if (reporte.ExternalpowerSupply === '1') {
        this.dispositivo[reporte.IMEI].alimentacionExternaClass = 'text-success';
        this.dispositivo[reporte.IMEI].alimentacionExterna = 'Conectado';
      }
    }
    //

    // Carga de batería
    if (reporte.Charging !== undefined) {
      if (reporte.Charging === '0') {
        this.dispositivo[reporte.IMEI].cargandoClass = 'text-warning';
        this.dispositivo[reporte.IMEI].cargando = 'N/A';
      } else if (reporte.Charging === '1') {
        this.dispositivo[reporte.IMEI].cargandoClass = 'text-success';
        this.dispositivo[reporte.IMEI].cargando = 'Cargando';
      }
    }
    //

    // Bateria
    if (reporte.BackupBatteryPorcentage !== undefined) {
      reporte.BackupBatteryPorcentage = parseInt(reporte.BackupBatteryPorcentage);
      this.dispositivo[reporte.IMEI].bateria = reporte.BackupBatteryPorcentage + '%';
      if (reporte.BackupBatteryPorcentage <= 40) {
        this.dispositivo[reporte.IMEI].bateriaClass = 'text-danger';
      }
      if (reporte.BackupBatteryPorcentage <= 70) {
        this.dispositivo[reporte.IMEI].bateriaClass = 'text-warning';
      }
      if (reporte.BackupBatteryPorcentage <= 100) {
        this.dispositivo[reporte.IMEI].bateriaClass = 'text-success';
      }
    }


  }

}
